//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import dayjs, { PluginFunc } from "dayjs";
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from "axios";

export class AttendanceClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getServiceAttendanceDailyAvg(serviceId: number, cancelToken?: CancelToken): Promise<ServiceAttendanceDailyAvg[]> {
    let url_ = this.baseUrl + "/api/v1/Attendance/service/{serviceId}/attendance-daily-avg";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceAttendanceDailyAvg(_response);
      });
  }

  protected processGetServiceAttendanceDailyAvg(response: AxiosResponse): Promise<ServiceAttendanceDailyAvg[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceAttendanceDailyAvg.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceAttendanceDailyAvg[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceAttendanceDailyAvg[]>(null as any);
  }

  getDailyAttendanceNumbersByService(
    serviceId: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    cancelToken?: CancelToken,
  ): Promise<SalesDataResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Attendance/daily-numbers/service/{serviceId}/from/{startDate}/to/{endDate}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (startDate === undefined || startDate === null)
      throw new globalThis.Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
    if (endDate === undefined || endDate === null)
      throw new globalThis.Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDailyAttendanceNumbersByService(_response);
      });
  }

  protected processGetDailyAttendanceNumbersByService(response: AxiosResponse): Promise<SalesDataResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SalesDataResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SalesDataResponse[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SalesDataResponse[]>(null as any);
  }

  getHolidayClubAttendanceNumberByService(
    serviceId: number,
    year: number,
    term: number,
    cancelToken?: CancelToken,
  ): Promise<HolidayClubAttendanceNumberResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Attendance/holiday-club-numbers/service/{serviceId}/year/{year}/term/{term}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    if (term === undefined || term === null) throw new globalThis.Error("The parameter 'term' must be defined.");
    url_ = url_.replace("{term}", encodeURIComponent("" + term));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetHolidayClubAttendanceNumberByService(_response);
      });
  }

  protected processGetHolidayClubAttendanceNumberByService(
    response: AxiosResponse,
  ): Promise<HolidayClubAttendanceNumberResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(HolidayClubAttendanceNumberResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<HolidayClubAttendanceNumberResponse[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<HolidayClubAttendanceNumberResponse[]>(null as any);
  }

  getHolidayClubAttendanceNumberByServiceAndDate(
    serviceId: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    cancelToken?: CancelToken,
  ): Promise<HolidayClubAttendanceNumberResponse[]> {
    let url_ =
      this.baseUrl + "/api/v1/Attendance/holiday-club-numbers/service/{serviceId}/from/{startDate}/to/{endDate}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (startDate === undefined || startDate === null)
      throw new globalThis.Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
    if (endDate === undefined || endDate === null)
      throw new globalThis.Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetHolidayClubAttendanceNumberByServiceAndDate(_response);
      });
  }

  protected processGetHolidayClubAttendanceNumberByServiceAndDate(
    response: AxiosResponse,
  ): Promise<HolidayClubAttendanceNumberResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(HolidayClubAttendanceNumberResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<HolidayClubAttendanceNumberResponse[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<HolidayClubAttendanceNumberResponse[]>(null as any);
  }

  downloadCsv(
    serviceId: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Attendance/download-csv/service/{serviceId}/from/{startDate}/to/{endDate}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (startDate === undefined || startDate === null)
      throw new globalThis.Error("The parameter 'startDate' must be defined.");
    url_ = url_.replace("{startDate}", encodeURIComponent(startDate ? "" + startDate.toISOString() : "null"));
    if (endDate === undefined || endDate === null)
      throw new globalThis.Error("The parameter 'endDate' must be defined.");
    url_ = url_.replace("{endDate}", encodeURIComponent(endDate ? "" + endDate.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadCsv(_response);
      });
  }

  protected processDownloadCsv(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class BookingsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getBookingsByServiceId(
    serviceId: number,
    date: dayjs.Dayjs,
    includeExcluded: boolean | undefined,
    excludeFeeWaiverBookings: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<ServiceBookingHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Bookings/service/{serviceId}/date/{date}?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (date === undefined || date === null) throw new globalThis.Error("The parameter 'date' must be defined.");
    url_ = url_.replace("{date}", encodeURIComponent(date ? "" + date.toISOString() : "null"));
    if (includeExcluded === null) throw new globalThis.Error("The parameter 'includeExcluded' cannot be null.");
    else if (includeExcluded !== undefined) url_ += "includeExcluded=" + encodeURIComponent("" + includeExcluded) + "&";
    if (excludeFeeWaiverBookings === null)
      throw new globalThis.Error("The parameter 'excludeFeeWaiverBookings' cannot be null.");
    else if (excludeFeeWaiverBookings !== undefined)
      url_ += "excludeFeeWaiverBookings=" + encodeURIComponent("" + excludeFeeWaiverBookings) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetBookingsByServiceId(_response);
      });
  }

  protected processGetBookingsByServiceId(response: AxiosResponse): Promise<ServiceBookingHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceBookingHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceBookingHttpResponse[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceBookingHttpResponse[]>(null as any);
  }

  getChildrenConfirmations(
    serviceId: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<ChildConfirmationHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Bookings/children-confirmations?";
    if (serviceId === null) throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
    else if (serviceId !== undefined) url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetChildrenConfirmations(_response);
      });
  }

  protected processGetChildrenConfirmations(response: AxiosResponse): Promise<ChildConfirmationHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ChildConfirmationHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ChildConfirmationHttpResponse[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChildConfirmationHttpResponse[]>(null as any);
  }

  saveChildrenConfirmations(request: SaveChildrenConfirmationsHttpRequest, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/Bookings/children-confirmations";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveChildrenConfirmations(_response);
      });
  }

  protected processSaveChildrenConfirmations(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getChildAtSchoolStatuses(cancelToken?: CancelToken): Promise<ChildAtSchoolStatusHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Bookings/child-at-school-statuses";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetChildAtSchoolStatuses(_response);
      });
  }

  protected processGetChildAtSchoolStatuses(response: AxiosResponse): Promise<ChildAtSchoolStatusHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ChildAtSchoolStatusHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ChildAtSchoolStatusHttpResponse[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ChildAtSchoolStatusHttpResponse[]>(null as any);
  }
}

export class ContentClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getNews(
    effectiveFrom: dayjs.Dayjs | null | undefined,
    effectiveTo: dayjs.Dayjs | null | undefined,
    contentLocation: ContentLocationEnum | undefined,
    isVisible: boolean | undefined,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<GetNewsResponse> {
    let url_ = this.baseUrl + "/api/v1/Content/news?";
    if (effectiveFrom !== undefined && effectiveFrom !== null)
      url_ += "effectiveFrom=" + encodeURIComponent(effectiveFrom ? "" + effectiveFrom.toISOString() : "") + "&";
    if (effectiveTo !== undefined && effectiveTo !== null)
      url_ += "effectiveTo=" + encodeURIComponent(effectiveTo ? "" + effectiveTo.toISOString() : "") + "&";
    if (contentLocation === null) throw new globalThis.Error("The parameter 'contentLocation' cannot be null.");
    else if (contentLocation !== undefined) url_ += "contentLocation=" + encodeURIComponent("" + contentLocation) + "&";
    if (isVisible === null) throw new globalThis.Error("The parameter 'isVisible' cannot be null.");
    else if (isVisible !== undefined) url_ += "isVisible=" + encodeURIComponent("" + isVisible) + "&";
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetNews(_response);
      });
  }

  protected processGetNews(response: AxiosResponse): Promise<GetNewsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetNewsResponse.fromJS(resultData200);
      return Promise.resolve<GetNewsResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException("A server side error occurred.", status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetNewsResponse>(null as any);
  }
}

export class DashboardClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getSessionDashboard(
    serviceId: number,
    sessionId: number,
    rollId: number,
    cancelToken?: CancelToken,
  ): Promise<SessionDashboardResponse> {
    let url_ = this.baseUrl + "/api/v1/Dashboard/service/{serviceId}/session/{sessionId}/roll/{rollId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (sessionId === undefined || sessionId === null)
      throw new globalThis.Error("The parameter 'sessionId' must be defined.");
    url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
    if (rollId === undefined || rollId === null) throw new globalThis.Error("The parameter 'rollId' must be defined.");
    url_ = url_.replace("{rollId}", encodeURIComponent("" + rollId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSessionDashboard(_response);
      });
  }

  protected processGetSessionDashboard(response: AxiosResponse): Promise<SessionDashboardResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SessionDashboardResponse.fromJS(resultData200);
      return Promise.resolve<SessionDashboardResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SessionDashboardResponse>(null as any);
  }
}

export class DocumentsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  downloadCurrentDigitalPrograms(serviceId: number, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Documents/digital-programs/{serviceId}/download";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadCurrentDigitalPrograms(_response);
      });
  }

  protected processDownloadCurrentDigitalPrograms(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  downloadServiceFlyer(serviceId: number, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Documents/service-flyer/{serviceId}/download";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadServiceFlyer(_response);
      });
  }

  protected processDownloadServiceFlyer(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getServiceTermReportDownload(
    serviceId: number,
    termNumber: number,
    termYear: number,
    forcePreview: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Documents/service/{serviceId}/term/{termNumber}/year/{termYear}/download?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (termNumber === undefined || termNumber === null)
      throw new globalThis.Error("The parameter 'termNumber' must be defined.");
    url_ = url_.replace("{termNumber}", encodeURIComponent("" + termNumber));
    if (termYear === undefined || termYear === null)
      throw new globalThis.Error("The parameter 'termYear' must be defined.");
    url_ = url_.replace("{termYear}", encodeURIComponent("" + termYear));
    if (forcePreview === null) throw new globalThis.Error("The parameter 'forcePreview' cannot be null.");
    else if (forcePreview !== undefined) url_ += "forcePreview=" + encodeURIComponent("" + forcePreview) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceTermReportDownload(_response);
      });
  }

  protected processGetServiceTermReportDownload(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getServiceMonthReportDownload(
    serviceId: number,
    month: number,
    year: number,
    forcePreview: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Documents/service/{serviceId}/month/{month}/year/{year}/download?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (month === undefined || month === null) throw new globalThis.Error("The parameter 'month' must be defined.");
    url_ = url_.replace("{month}", encodeURIComponent("" + month));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    if (forcePreview === null) throw new globalThis.Error("The parameter 'forcePreview' cannot be null.");
    else if (forcePreview !== undefined) url_ += "forcePreview=" + encodeURIComponent("" + forcePreview) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceMonthReportDownload(_response);
      });
  }

  protected processGetServiceMonthReportDownload(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getServiceYearReportDownload(
    serviceId: number,
    year: number,
    forcePreview: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Documents/service/{serviceId}/year/{year}/download?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    if (forcePreview === null) throw new globalThis.Error("The parameter 'forcePreview' cannot be null.");
    else if (forcePreview !== undefined) url_ += "forcePreview=" + encodeURIComponent("" + forcePreview) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceYearReportDownload(_response);
      });
  }

  protected processGetServiceYearReportDownload(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class EducatorsClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getServiceEmployeesForCurrentWeek(serviceId: number, cancelToken?: CancelToken): Promise<EmployeePosition[]> {
    let url_ = this.baseUrl + "/api/v1/Educators/service/{serviceId}/this-week";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceEmployeesForCurrentWeek(_response);
      });
  }

  protected processGetServiceEmployeesForCurrentWeek(response: AxiosResponse): Promise<EmployeePosition[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(EmployeePosition.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<EmployeePosition[]>(result200);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<EmployeePosition[]>(null as any);
  }

  getServiceEmployeesWorkedInDateRange(
    serviceId: number,
    startDate: dayjs.Dayjs | undefined,
    endDate: dayjs.Dayjs | undefined,
    cancelToken?: CancelToken,
  ): Promise<EmployeePosition[]> {
    let url_ = this.baseUrl + "/api/v1/Educators/service/{serviceId}/worked-in-date-range?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (startDate === null) throw new globalThis.Error("The parameter 'startDate' cannot be null.");
    else if (startDate !== undefined)
      url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
    if (endDate === null) throw new globalThis.Error("The parameter 'endDate' cannot be null.");
    else if (endDate !== undefined)
      url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceEmployeesWorkedInDateRange(_response);
      });
  }

  protected processGetServiceEmployeesWorkedInDateRange(response: AxiosResponse): Promise<EmployeePosition[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(EmployeePosition.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<EmployeePosition[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<EmployeePosition[]>(null as any);
  }

  downloadEmployeePhoto(
    employeeId: number,
    includeDeleted: boolean | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/Educators/photo/{employeeId}?";
    if (employeeId === undefined || employeeId === null)
      throw new globalThis.Error("The parameter 'employeeId' must be defined.");
    url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
    if (includeDeleted !== undefined && includeDeleted !== null)
      url_ += "includeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDownloadEmployeePhoto(_response);
      });
  }

  protected processDownloadEmployeePhoto(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status === 404) {
      const _responseText = response.data;
      let result404: any = null;
      let resultData404 = _responseText;
      result404 = ProblemDetails.fromJS(resultData404);
      return throwException("A server side error occurred.", status, _responseText, _headers, result404);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class FeeInformationFlyerClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getFeeInformationFlyer(
    serviceId: number,
    date: dayjs.Dayjs | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<FeeInformationFlyerViewModel> {
    let url_ = this.baseUrl + "/api/v1/FeeInformationFlyer/service/{serviceId}?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (date !== undefined && date !== null)
      url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFeeInformationFlyer(_response);
      });
  }

  protected processGetFeeInformationFlyer(response: AxiosResponse): Promise<FeeInformationFlyerViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FeeInformationFlyerViewModel.fromJS(resultData200);
      return Promise.resolve<FeeInformationFlyerViewModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FeeInformationFlyerViewModel>(null as any);
  }

  checkPendingFeeReview(serviceId: number, cancelToken?: CancelToken): Promise<FeePendingReviewResponse> {
    let url_ = this.baseUrl + "/api/v1/FeeInformationFlyer/service/{serviceId}/pending-review";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCheckPendingFeeReview(_response);
      });
  }

  protected processCheckPendingFeeReview(response: AxiosResponse): Promise<FeePendingReviewResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FeePendingReviewResponse.fromJS(resultData200);
      return Promise.resolve<FeePendingReviewResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FeePendingReviewResponse>(null as any);
  }

  getFboFeeInformationFlyer(
    serviceId: number,
    date: dayjs.Dayjs | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<FeeInformationFlyerViewModel> {
    let url_ = this.baseUrl + "/api/v1/FeeInformationFlyer/service/{serviceId}/fbo?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (date !== undefined && date !== null)
      url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetFboFeeInformationFlyer(_response);
      });
  }

  protected processGetFboFeeInformationFlyer(response: AxiosResponse): Promise<FeeInformationFlyerViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FeeInformationFlyerViewModel.fromJS(resultData200);
      return Promise.resolve<FeeInformationFlyerViewModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FeeInformationFlyerViewModel>(null as any);
  }

  saveFeeQuery(
    serviceId: number,
    request: FeeQuerySaveRequest,
    cancelToken?: CancelToken,
  ): Promise<FeeQuerySaveResponse> {
    let url_ = this.baseUrl + "/api/v1/FeeInformationFlyer/service/{serviceId}/fee-query";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSaveFeeQuery(_response);
      });
  }

  protected processSaveFeeQuery(response: AxiosResponse): Promise<FeeQuerySaveResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = FeeQuerySaveResponse.fromJS(resultData200);
      return Promise.resolve<FeeQuerySaveResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FeeQuerySaveResponse>(null as any);
  }
}

export class HolidayClubClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getProgramDates(
    serviceId: number,
    year: number | null | undefined,
    cancelToken?: CancelToken,
  ): Promise<ProgramDateExtended[]> {
    let url_ = this.baseUrl + "/api/v1/HolidayClub/service/{serviceId}/dates?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year !== undefined && year !== null) url_ += "year=" + encodeURIComponent("" + year) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProgramDates(_response);
      });
  }

  protected processGetProgramDates(response: AxiosResponse): Promise<ProgramDateExtended[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ProgramDateExtended.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ProgramDateExtended[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProgramDateExtended[]>(null as any);
  }

  confirmProgramDate(programDateId: number, userId: string, cancelToken?: CancelToken): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/HolidayClub/dates/{programDateId}/confirm";
    if (programDateId === undefined || programDateId === null)
      throw new globalThis.Error("The parameter 'programDateId' must be defined.");
    url_ = url_.replace("{programDateId}", encodeURIComponent("" + programDateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(userId);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmProgramDate(_response);
      });
  }

  protected processConfirmProgramDate(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  confirmAllProgramDates(
    serviceId: number,
    request: ConfirmAllDatesRequest,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/HolidayClub/service/{serviceId}/dates/confirm-all";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmAllProgramDates(_response);
      });
  }

  protected processConfirmAllProgramDates(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  setProgramDateRestrictions(
    programDateId: number,
    request: SetRestrictionsRequest,
    cancelToken?: CancelToken,
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/v1/HolidayClub/dates/{programDateId}/restrictions";
    if (programDateId === undefined || programDateId === null)
      throw new globalThis.Error("The parameter 'programDateId' must be defined.");
    url_ = url_.replace("{programDateId}", encodeURIComponent("" + programDateId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/octet-stream",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSetProgramDateRestrictions(_response);
      });
  }

  protected processSetProgramDateRestrictions(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
      let fileNameMatch = contentDisposition
        ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
        : undefined;
      let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
      if (fileName) {
        fileName = decodeURIComponent(fileName);
      } else {
        fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
        fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
      }
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], { type: response.headers["content-type"]?.toString() }),
        headers: _headers,
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<FileResponse>(null as any);
  }

  getUpcomingProgramDateActivities(serviceId: number, cancelToken?: CancelToken): Promise<ProgramDateExtended[]> {
    let url_ = this.baseUrl + "/api/v1/HolidayClub/service/{serviceId}/upcoming-dates-activities";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetUpcomingProgramDateActivities(_response);
      });
  }

  protected processGetUpcomingProgramDateActivities(response: AxiosResponse): Promise<ProgramDateExtended[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ProgramDateExtended.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ProgramDateExtended[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ProgramDateExtended[]>(null as any);
  }
}

export class KeyDatesClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getKeyDatesViewModel(serviceId: number, year: number, cancelToken?: CancelToken): Promise<KeyDatesViewModel> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/service/{serviceId}/year/{year}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetKeyDatesViewModel(_response);
      });
  }

  protected processGetKeyDatesViewModel(response: AxiosResponse): Promise<KeyDatesViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KeyDatesViewModel.fromJS(resultData200);
      return Promise.resolve<KeyDatesViewModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KeyDatesViewModel>(null as any);
  }

  getKeyDatesViewModel2(serviceId: number, cancelToken?: CancelToken): Promise<KeyDatesViewModel> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/service/{serviceId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetKeyDatesViewModel2(_response);
      });
  }

  protected processGetKeyDatesViewModel2(response: AxiosResponse): Promise<KeyDatesViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = KeyDatesViewModel.fromJS(resultData200);
      return Promise.resolve<KeyDatesViewModel>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KeyDatesViewModel>(null as any);
  }

  getPfdServiceTypes(cancelToken?: CancelToken): Promise<PfdServiceTypeHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/pfd/service-types";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPfdServiceTypes(_response);
      });
  }

  protected processGetPfdServiceTypes(response: AxiosResponse): Promise<PfdServiceTypeHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(PfdServiceTypeHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<PfdServiceTypeHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PfdServiceTypeHttpResponse[]>(null as any);
  }

  getPupilFreeDays(serviceId: number, year: number, cancelToken?: CancelToken): Promise<PupilFreeDayHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/pfd/service/{serviceId}/year/{year}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPupilFreeDays(_response);
      });
  }

  protected processGetPupilFreeDays(response: AxiosResponse): Promise<PupilFreeDayHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(PupilFreeDayHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<PupilFreeDayHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<PupilFreeDayHttpResponse[]>(null as any);
  }

  getSuggestedPfds(
    serviceId: number,
    year: number,
    excludeConfirmed: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<SuggestedPfdHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/pfd/suggested/service/{serviceId}/year/{year}?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    if (excludeConfirmed === null) throw new globalThis.Error("The parameter 'excludeConfirmed' cannot be null.");
    else if (excludeConfirmed !== undefined)
      url_ += "excludeConfirmed=" + encodeURIComponent("" + excludeConfirmed) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSuggestedPfds(_response);
      });
  }

  protected processGetSuggestedPfds(response: AxiosResponse): Promise<SuggestedPfdHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SuggestedPfdHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SuggestedPfdHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SuggestedPfdHttpResponse[]>(null as any);
  }

  suggestPfd(
    serviceId: number,
    request: SuggestPfdRequest,
    cancelToken?: CancelToken,
  ): Promise<SuggestedPfdHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/pfd/{serviceId}/suggest";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSuggestPfd(_response);
      });
  }

  protected processSuggestPfd(response: AxiosResponse): Promise<SuggestedPfdHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = SuggestedPfdHttpResponse.fromJS(resultData201);
      return Promise.resolve<SuggestedPfdHttpResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SuggestedPfdHttpResponse>(null as any);
  }

  savePfd(serviceId: number, request: SavePfdRequest, cancelToken?: CancelToken): Promise<SuggestedPfdHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/pfd/{serviceId}/save";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSavePfd(_response);
      });
  }

  protected processSavePfd(response: AxiosResponse): Promise<SuggestedPfdHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SuggestedPfdHttpResponse.fromJS(resultData200);
      return Promise.resolve<SuggestedPfdHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SuggestedPfdHttpResponse>(null as any);
  }

  deletePfd(serviceId: number, pupilFreeDaySuggestionId: number, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/pfd/service/{serviceId}/suggestion/{pupilFreeDaySuggestionId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (pupilFreeDaySuggestionId === undefined || pupilFreeDaySuggestionId === null)
      throw new globalThis.Error("The parameter 'pupilFreeDaySuggestionId' must be defined.");
    url_ = url_.replace("{pupilFreeDaySuggestionId}", encodeURIComponent("" + pupilFreeDaySuggestionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeletePfd(_response);
      });
  }

  protected processDeletePfd(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }

  getDefaultTermDates(
    serviceId: number,
    year: number,
    cancelToken?: CancelToken,
  ): Promise<DefaultTermDateHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/term-dates/default/service/{serviceId}/year/{year}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDefaultTermDates(_response);
      });
  }

  protected processGetDefaultTermDates(response: AxiosResponse): Promise<DefaultTermDateHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(DefaultTermDateHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<DefaultTermDateHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DefaultTermDateHttpResponse[]>(null as any);
  }

  getDefaultTermDatesFromYear(
    serviceId: number,
    year: number,
    cancelToken?: CancelToken,
  ): Promise<DefaultTermDateHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/term-dates/default/service/{serviceId}/from/year/{year}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDefaultTermDatesFromYear(_response);
      });
  }

  protected processGetDefaultTermDatesFromYear(response: AxiosResponse): Promise<DefaultTermDateHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(DefaultTermDateHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<DefaultTermDateHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<DefaultTermDateHttpResponse[]>(null as any);
  }

  getSuggestedTermDates(
    serviceId: number,
    year: number,
    excludeConfirmed: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<SuggestedTermDateHttpResponse[]> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/term-dates/suggested/service/{serviceId}/year/{year}?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (year === undefined || year === null) throw new globalThis.Error("The parameter 'year' must be defined.");
    url_ = url_.replace("{year}", encodeURIComponent("" + year));
    if (excludeConfirmed === null) throw new globalThis.Error("The parameter 'excludeConfirmed' cannot be null.");
    else if (excludeConfirmed !== undefined)
      url_ += "excludeConfirmed=" + encodeURIComponent("" + excludeConfirmed) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSuggestedTermDates(_response);
      });
  }

  protected processGetSuggestedTermDates(response: AxiosResponse): Promise<SuggestedTermDateHttpResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SuggestedTermDateHttpResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SuggestedTermDateHttpResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SuggestedTermDateHttpResponse[]>(null as any);
  }

  suggestTermDate(
    serviceId: number,
    request: SuggestTermDateRequest,
    cancelToken?: CancelToken,
  ): Promise<SuggestedTermDateHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/term-dates/{serviceId}/suggest";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSuggestTermDate(_response);
      });
  }

  protected processSuggestTermDate(response: AxiosResponse): Promise<SuggestedTermDateHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 201) {
      const _responseText = response.data;
      let result201: any = null;
      let resultData201 = _responseText;
      result201 = SuggestedTermDateHttpResponse.fromJS(resultData201);
      return Promise.resolve<SuggestedTermDateHttpResponse>(result201);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SuggestedTermDateHttpResponse>(null as any);
  }

  editSuggestedTermDate(
    serviceId: number,
    request: EditSuggestedTermDateRequest,
    cancelToken?: CancelToken,
  ): Promise<SuggestedTermDateHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/term-dates/{serviceId}/suggest";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processEditSuggestedTermDate(_response);
      });
  }

  protected processEditSuggestedTermDate(response: AxiosResponse): Promise<SuggestedTermDateHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SuggestedTermDateHttpResponse.fromJS(resultData200);
      return Promise.resolve<SuggestedTermDateHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SuggestedTermDateHttpResponse>(null as any);
  }

  confirmTermDate(
    serviceId: number,
    request: ConfirmTermDateRequest,
    cancelToken?: CancelToken,
  ): Promise<TermDateHttpResponse> {
    let url_ = this.baseUrl + "/api/v1/KeyDates/term-dates/{serviceId}/confirm";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmTermDate(_response);
      });
  }

  protected processConfirmTermDate(response: AxiosResponse): Promise<TermDateHttpResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TermDateHttpResponse.fromJS(resultData200);
      return Promise.resolve<TermDateHttpResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<TermDateHttpResponse>(null as any);
  }
}

export class OperationalInformationClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getComplaintList(
    serviceId: number | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    sortBy: string | null | undefined,
    sortDescending: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<ComplaintListResponse> {
    let url_ = this.baseUrl + "/api/v1/OperationalInformation/complaints?";
    if (serviceId === null) throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
    else if (serviceId !== undefined) url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
    if (pageNumber === null) throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (sortBy !== undefined && sortBy !== null) url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortDescending === null) throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
    else if (sortDescending !== undefined) url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetComplaintList(_response);
      });
  }

  protected processGetComplaintList(response: AxiosResponse): Promise<ComplaintListResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ComplaintListResponse.fromJS(resultData200);
      return Promise.resolve<ComplaintListResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ComplaintListResponse>(null as any);
  }

  getIncidentsList(
    serviceId: number | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    sortBy: string | null | undefined,
    sortDescending: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/OperationalInformation/incidents?";
    if (serviceId === null) throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
    else if (serviceId !== undefined) url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
    if (pageNumber === null) throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (sortBy !== undefined && sortBy !== null) url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortDescending === null) throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
    else if (sortDescending !== undefined) url_ += "sortDescending=" + encodeURIComponent("" + sortDescending) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetIncidentsList(_response);
      });
  }

  protected processGetIncidentsList(response: AxiosResponse): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<any>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<any>(null as any);
  }

  getExcludedChildren(
    serviceId: number | undefined,
    page: number | undefined,
    pageSize: number | undefined,
    cancelToken?: CancelToken,
  ): Promise<any> {
    let url_ = this.baseUrl + "/api/v1/OperationalInformation/excluded-children?";
    if (serviceId === null) throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
    else if (serviceId !== undefined) url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
    if (page === null) throw new globalThis.Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += "page=" + encodeURIComponent("" + page) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetExcludedChildren(_response);
      });
  }

  protected processGetExcludedChildren(response: AxiosResponse): Promise<any> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<any>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status === 401) {
      const _responseText = response.data;
      let result401: any = null;
      let resultData401 = _responseText;
      result401 = ProblemDetails.fromJS(resultData401);
      return throwException("A server side error occurred.", status, _responseText, _headers, result401);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<any>(null as any);
  }
}

export class PartnershipRequestClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  createPartnershipRequest(
    serviceId: number,
    request: CreatePartnershipRequestRequest,
    cancelToken?: CancelToken,
  ): Promise<number> {
    let url_ = this.baseUrl + "/api/v1/PartnershipRequest/service/{serviceId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreatePartnershipRequest(_response);
      });
  }

  protected processCreatePartnershipRequest(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<number>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<number>(null as any);
  }

  getPartnershipRequests(
    serviceId: number,
    issueStatusId: WorkflowIssueStatusEnum | null | undefined,
    pageNumber: number | undefined,
    pageSize: number | undefined,
    sortBy: string | null | undefined,
    sortDescending: boolean | undefined,
    cancelToken?: CancelToken,
  ): Promise<GetPartnershipRequestsResponse> {
    let url_ = this.baseUrl + "/api/v1/PartnershipRequest/service/{serviceId}?";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (issueStatusId !== undefined && issueStatusId !== null)
      url_ += "IssueStatusId=" + encodeURIComponent("" + issueStatusId) + "&";
    if (pageNumber === null) throw new globalThis.Error("The parameter 'pageNumber' cannot be null.");
    else if (pageNumber !== undefined) url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
    if (pageSize === null) throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
    if (sortBy !== undefined && sortBy !== null) url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortDescending === null) throw new globalThis.Error("The parameter 'sortDescending' cannot be null.");
    else if (sortDescending !== undefined) url_ += "SortDescending=" + encodeURIComponent("" + sortDescending) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPartnershipRequests(_response);
      });
  }

  protected processGetPartnershipRequests(response: AxiosResponse): Promise<GetPartnershipRequestsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GetPartnershipRequestsResponse.fromJS(resultData200);
      return Promise.resolve<GetPartnershipRequestsResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetPartnershipRequestsResponse>(null as any);
  }

  reopenPartnershipRequest(
    serviceId: number,
    issueId: number,
    request: ReopenPartnershipRequestRequest,
    cancelToken?: CancelToken,
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/api/v1/PartnershipRequest/service/{serviceId}/{issueId}/reopen";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (issueId === undefined || issueId === null)
      throw new globalThis.Error("The parameter 'issueId' must be defined.");
    url_ = url_.replace("{issueId}", encodeURIComponent("" + issueId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processReopenPartnershipRequest(_response);
      });
  }

  protected processReopenPartnershipRequest(response: AxiosResponse): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : (null as any);

      return Promise.resolve<boolean>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = ProblemDetails.fromJS(resultData400);
      return throwException("A server side error occurred.", status, _responseText, _headers, result400);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<boolean>(null as any);
  }
}

export class SchoolContactClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  listServicesForContact(cancelToken?: CancelToken): Promise<SchoolContactServiceResponse[]> {
    let url_ = this.baseUrl + "/api/v1/SchoolContact/list-contact-services";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processListServicesForContact(_response);
      });
  }

  protected processListServicesForContact(response: AxiosResponse): Promise<SchoolContactServiceResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SchoolContactServiceResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SchoolContactServiceResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SchoolContactServiceResponse[]>(null as any);
  }

  getSchoolContactsByServiceId(
    serviceId: number,
    cancelToken?: CancelToken,
  ): Promise<SchoolContactWithPermissionResponse[]> {
    let url_ = this.baseUrl + "/api/v1/SchoolContact/service/{serviceId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetSchoolContactsByServiceId(_response);
      });
  }

  protected processGetSchoolContactsByServiceId(
    response: AxiosResponse,
  ): Promise<SchoolContactWithPermissionResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SchoolContactWithPermissionResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<SchoolContactWithPermissionResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<SchoolContactWithPermissionResponse[]>(null as any);
  }

  getCrmPositions(cancelToken?: CancelToken): Promise<GetCrmPositionsResponse[]> {
    let url_ = this.baseUrl + "/api/v1/SchoolContact/crm-positions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetCrmPositions(_response);
      });
  }

  protected processGetCrmPositions(response: AxiosResponse): Promise<GetCrmPositionsResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(GetCrmPositionsResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<GetCrmPositionsResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<GetCrmPositionsResponse[]>(null as any);
  }

  createSchoolContact(
    serviceId: number,
    request: CreateSchoolContactRequest,
    cancelToken?: CancelToken,
  ): Promise<ApiResponseResultOfSchoolContactWithPermissionResponse> {
    let url_ = this.baseUrl + "/api/v1/SchoolContact/service/{serviceId}/contacts";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreateSchoolContact(_response);
      });
  }

  protected processCreateSchoolContact(
    response: AxiosResponse,
  ): Promise<ApiResponseResultOfSchoolContactWithPermissionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ApiResponseResultOfSchoolContactWithPermissionResponse.fromJS(resultData200);
      return Promise.resolve<ApiResponseResultOfSchoolContactWithPermissionResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ApiResponseResultOfSchoolContactWithPermissionResponse>(null as any);
  }

  updateSchoolContact(
    serviceId: number,
    schoolContactId: number,
    request: UpdateSchoolContactRequest,
    cancelToken?: CancelToken,
  ): Promise<ApiResponseResultOfSchoolContactWithPermissionResponse> {
    let url_ = this.baseUrl + "/api/v1/SchoolContact/service/{serviceId}/contacts/{schoolContactId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (schoolContactId === undefined || schoolContactId === null)
      throw new globalThis.Error("The parameter 'schoolContactId' must be defined.");
    url_ = url_.replace("{schoolContactId}", encodeURIComponent("" + schoolContactId));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: "PUT",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateSchoolContact(_response);
      });
  }

  protected processUpdateSchoolContact(
    response: AxiosResponse,
  ): Promise<ApiResponseResultOfSchoolContactWithPermissionResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ApiResponseResultOfSchoolContactWithPermissionResponse.fromJS(resultData200);
      return Promise.resolve<ApiResponseResultOfSchoolContactWithPermissionResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ApiResponseResultOfSchoolContactWithPermissionResponse>(null as any);
  }

  deleteSchoolContact(serviceId: number, schoolContactId: number, cancelToken?: CancelToken): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/SchoolContact/service/{serviceId}/contacts/{schoolContactId}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (schoolContactId === undefined || schoolContactId === null)
      throw new globalThis.Error("The parameter 'schoolContactId' must be defined.");
    url_ = url_.replace("{schoolContactId}", encodeURIComponent("" + schoolContactId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "DELETE",
      url: url_,
      headers: {},
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteSchoolContact(_response);
      });
  }

  protected processDeleteSchoolContact(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
  }
}

export class ServiceClient {
  protected instance: AxiosInstance;
  protected baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance || axios.create();

    this.baseUrl = baseUrl ?? "";
  }

  getServiceVisitDocuments(
    serviceId: number,
    from: dayjs.Dayjs,
    to: dayjs.Dayjs,
    cancelToken?: CancelToken,
  ): Promise<ServiceVisitDocumentDto[]> {
    let url_ = this.baseUrl + "/api/v1/Service/{serviceId}/visit-documents/from/{from}/to/{to}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (from === undefined || from === null) throw new globalThis.Error("The parameter 'from' must be defined.");
    url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
    if (to === undefined || to === null) throw new globalThis.Error("The parameter 'to' must be defined.");
    url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceVisitDocuments(_response);
      });
  }

  protected processGetServiceVisitDocuments(response: AxiosResponse): Promise<ServiceVisitDocumentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceVisitDocumentDto.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceVisitDocumentDto[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceVisitDocumentDto[]>(null as any);
  }

  getKeyContacts(serviceId: number, cancelToken?: CancelToken): Promise<KeyContactResponse[]> {
    let url_ = this.baseUrl + "/api/v1/Service/{serviceId}/key-contacts";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetKeyContacts(_response);
      });
  }

  protected processGetKeyContacts(response: AxiosResponse): Promise<KeyContactResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(KeyContactResponse.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<KeyContactResponse[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<KeyContactResponse[]>(null as any);
  }

  getServiceSessionsByDateRange(
    serviceId: number,
    from: dayjs.Dayjs,
    to: dayjs.Dayjs,
    cancelToken?: CancelToken,
  ): Promise<ServiceSession[]> {
    let url_ = this.baseUrl + "/api/v1/Service/{serviceId}/sessions/from/{from}/to/{to}";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    if (from === undefined || from === null) throw new globalThis.Error("The parameter 'from' must be defined.");
    url_ = url_.replace("{from}", encodeURIComponent(from ? "" + from.toISOString() : "null"));
    if (to === undefined || to === null) throw new globalThis.Error("The parameter 'to' must be defined.");
    url_ = url_.replace("{to}", encodeURIComponent(to ? "" + to.toISOString() : "null"));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceSessionsByDateRange(_response);
      });
  }

  protected processGetServiceSessionsByDateRange(response: AxiosResponse): Promise<ServiceSession[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceSession.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceSession[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceSession[]>(null as any);
  }

  getServiceSessionsAroundNow(serviceId: number, cancelToken?: CancelToken): Promise<ServiceSession[]> {
    let url_ = this.baseUrl + "/api/v1/Service/{serviceId}/sessions/around-now";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceSessionsAroundNow(_response);
      });
  }

  protected processGetServiceSessionsAroundNow(response: AxiosResponse): Promise<ServiceSession[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(ServiceSession.fromJS(item));
      } else {
        result200 = null as any;
      }
      return Promise.resolve<ServiceSession[]>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceSession[]>(null as any);
  }

  getServiceAdditionalInfo(serviceId: number, cancelToken?: CancelToken): Promise<ServiceAdditionalInfoResponse> {
    let url_ = this.baseUrl + "/api/v1/Service/{serviceId}/additional-info";
    if (serviceId === undefined || serviceId === null)
      throw new globalThis.Error("The parameter 'serviceId' must be defined.");
    url_ = url_.replace("{serviceId}", encodeURIComponent("" + serviceId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json",
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetServiceAdditionalInfo(_response);
      });
  }

  protected processGetServiceAdditionalInfo(response: AxiosResponse): Promise<ServiceAdditionalInfoResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (const k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ServiceAdditionalInfoResponse.fromJS(resultData200);
      return Promise.resolve<ServiceAdditionalInfoResponse>(result200);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<ServiceAdditionalInfoResponse>(null as any);
  }
}

export class ServiceAttendanceDailyAvg implements IServiceAttendanceDailyAvg {
  id?: number | undefined;
  serviceId!: number;
  careTypeId!: number;
  careTypeDescription?: string | undefined;
  monday!: number;
  tuesday!: number;
  wednesday!: number;
  thursday!: number;
  friday!: number;

  constructor(data?: IServiceAttendanceDailyAvg) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.serviceId = _data["serviceId"];
      this.careTypeId = _data["careTypeId"];
      this.careTypeDescription = _data["careTypeDescription"];
      this.monday = _data["monday"];
      this.tuesday = _data["tuesday"];
      this.wednesday = _data["wednesday"];
      this.thursday = _data["thursday"];
      this.friday = _data["friday"];
    }
  }

  static fromJS(data: any): ServiceAttendanceDailyAvg {
    data = typeof data === "object" ? data : {};
    let result = new ServiceAttendanceDailyAvg();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["serviceId"] = this.serviceId;
    data["careTypeId"] = this.careTypeId;
    data["careTypeDescription"] = this.careTypeDescription;
    data["monday"] = this.monday;
    data["tuesday"] = this.tuesday;
    data["wednesday"] = this.wednesday;
    data["thursday"] = this.thursday;
    data["friday"] = this.friday;
    return data;
  }
}

export interface IServiceAttendanceDailyAvg {
  id?: number | undefined;
  serviceId: number;
  careTypeId: number;
  careTypeDescription?: string | undefined;
  monday: number;
  tuesday: number;
  wednesday: number;
  thursday: number;
  friday: number;
}

export class SalesDataResponse implements ISalesDataResponse {
  serviceId!: number;
  weekBegin!: dayjs.Dayjs;
  date!: dayjs.Dayjs;
  code!: string;
  numBk!: number;
  dayOfWeek!: string;

  constructor(data?: ISalesDataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.weekBegin = _data["weekBegin"] ? dayjs(_data["weekBegin"].toString()) : (undefined as any);
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.code = _data["code"];
      this.numBk = _data["numBk"];
      this.dayOfWeek = _data["dayOfWeek"];
    }
  }

  static fromJS(data: any): SalesDataResponse {
    data = typeof data === "object" ? data : {};
    let result = new SalesDataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["weekBegin"] = this.weekBegin ? this.weekBegin.toISOString() : (undefined as any);
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["code"] = this.code;
    data["numBk"] = this.numBk;
    data["dayOfWeek"] = this.dayOfWeek;
    return data;
  }
}

export interface ISalesDataResponse {
  serviceId: number;
  weekBegin: dayjs.Dayjs;
  date: dayjs.Dayjs;
  code: string;
  numBk: number;
  dayOfWeek: string;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      for (var property in _data) {
        if (_data.hasOwnProperty(property)) this[property] = _data[property];
      }
      this.type = _data["type"];
      this.title = _data["title"];
      this.status = _data["status"];
      this.detail = _data["detail"];
      this.instance = _data["instance"];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === "object" ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    for (var property in this) {
      if (this.hasOwnProperty(property)) data[property] = this[property];
    }
    data["type"] = this.type;
    data["title"] = this.title;
    data["status"] = this.status;
    data["detail"] = this.detail;
    data["instance"] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  [key: string]: any;
}

export class HolidayClubAttendanceNumberResponse implements IHolidayClubAttendanceNumberResponse {
  serviceId!: number;
  bookingDate!: dayjs.Dayjs;
  value!: number;

  constructor(data?: IHolidayClubAttendanceNumberResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.bookingDate = _data["bookingDate"] ? dayjs(_data["bookingDate"].toString()) : (undefined as any);
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): HolidayClubAttendanceNumberResponse {
    data = typeof data === "object" ? data : {};
    let result = new HolidayClubAttendanceNumberResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : (undefined as any);
    data["value"] = this.value;
    return data;
  }
}

export interface IHolidayClubAttendanceNumberResponse {
  serviceId: number;
  bookingDate: dayjs.Dayjs;
  value: number;
}

export class ServiceBookingHttpResponse implements IServiceBookingHttpResponse {
  bookingDate!: dayjs.Dayjs;
  bookingId!: number;
  scheduleId?: number | undefined;
  childId!: number;
  childFirstName?: string | undefined;
  childSurname?: string | undefined;
  childAge?: number | undefined;
  childCurrentAge?: number | undefined;
  childGender?: string | undefined;
  serviceId!: number;
  serviceName?: string | undefined;
  careTypeId!: number;
  careTypeCode?: string | undefined;
  careTypeDescription?: string | undefined;
  attended?: boolean | undefined;
  booked?: number | undefined;
  parentFirstName?: string | undefined;
  parentLastName?: string | undefined;
  rollId!: number;
  rollName!: string;
  primaryServiceId?: number | undefined;
  primaryServiceName?: string | undefined;
  childPreferredSchoolId?: number | undefined;
  childPreferredSchoolName?: string | undefined;
  childPreferredServiceId?: number | undefined;
  childPreferredServiceName?: string | undefined;
  isExcluded?: boolean | undefined;
  rollMarkingTimeIn?: dayjs.Dayjs | undefined;
  rollMarkingTimeOut?: dayjs.Dayjs | undefined;

  constructor(data?: IServiceBookingHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.bookingDate = _data["bookingDate"] ? dayjs(_data["bookingDate"].toString()) : (undefined as any);
      this.bookingId = _data["bookingId"];
      this.scheduleId = _data["scheduleId"];
      this.childId = _data["childId"];
      this.childFirstName = _data["childFirstName"];
      this.childSurname = _data["childSurname"];
      this.childAge = _data["childAge"];
      this.childCurrentAge = _data["childCurrentAge"];
      this.childGender = _data["childGender"];
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.careTypeId = _data["careTypeId"];
      this.careTypeCode = _data["careTypeCode"];
      this.careTypeDescription = _data["careTypeDescription"];
      this.attended = _data["attended"];
      this.booked = _data["booked"];
      this.parentFirstName = _data["parentFirstName"];
      this.parentLastName = _data["parentLastName"];
      this.rollId = _data["rollId"];
      this.rollName = _data["rollName"];
      this.primaryServiceId = _data["primaryServiceId"];
      this.primaryServiceName = _data["primaryServiceName"];
      this.childPreferredSchoolId = _data["childPreferredSchoolId"];
      this.childPreferredSchoolName = _data["childPreferredSchoolName"];
      this.childPreferredServiceId = _data["childPreferredServiceId"];
      this.childPreferredServiceName = _data["childPreferredServiceName"];
      this.isExcluded = _data["isExcluded"];
      this.rollMarkingTimeIn = _data["rollMarkingTimeIn"]
        ? dayjs(_data["rollMarkingTimeIn"].toString())
        : (undefined as any);
      this.rollMarkingTimeOut = _data["rollMarkingTimeOut"]
        ? dayjs(_data["rollMarkingTimeOut"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): ServiceBookingHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ServiceBookingHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["bookingDate"] = this.bookingDate ? this.bookingDate.toISOString() : (undefined as any);
    data["bookingId"] = this.bookingId;
    data["scheduleId"] = this.scheduleId;
    data["childId"] = this.childId;
    data["childFirstName"] = this.childFirstName;
    data["childSurname"] = this.childSurname;
    data["childAge"] = this.childAge;
    data["childCurrentAge"] = this.childCurrentAge;
    data["childGender"] = this.childGender;
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["careTypeId"] = this.careTypeId;
    data["careTypeCode"] = this.careTypeCode;
    data["careTypeDescription"] = this.careTypeDescription;
    data["attended"] = this.attended;
    data["booked"] = this.booked;
    data["parentFirstName"] = this.parentFirstName;
    data["parentLastName"] = this.parentLastName;
    data["rollId"] = this.rollId;
    data["rollName"] = this.rollName;
    data["primaryServiceId"] = this.primaryServiceId;
    data["primaryServiceName"] = this.primaryServiceName;
    data["childPreferredSchoolId"] = this.childPreferredSchoolId;
    data["childPreferredSchoolName"] = this.childPreferredSchoolName;
    data["childPreferredServiceId"] = this.childPreferredServiceId;
    data["childPreferredServiceName"] = this.childPreferredServiceName;
    data["isExcluded"] = this.isExcluded;
    data["rollMarkingTimeIn"] = this.rollMarkingTimeIn
      ? this.rollMarkingTimeIn.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["rollMarkingTimeOut"] = this.rollMarkingTimeOut
      ? this.rollMarkingTimeOut.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    return data;
  }
}

export interface IServiceBookingHttpResponse {
  bookingDate: dayjs.Dayjs;
  bookingId: number;
  scheduleId?: number | undefined;
  childId: number;
  childFirstName?: string | undefined;
  childSurname?: string | undefined;
  childAge?: number | undefined;
  childCurrentAge?: number | undefined;
  childGender?: string | undefined;
  serviceId: number;
  serviceName?: string | undefined;
  careTypeId: number;
  careTypeCode?: string | undefined;
  careTypeDescription?: string | undefined;
  attended?: boolean | undefined;
  booked?: number | undefined;
  parentFirstName?: string | undefined;
  parentLastName?: string | undefined;
  rollId: number;
  rollName: string;
  primaryServiceId?: number | undefined;
  primaryServiceName?: string | undefined;
  childPreferredSchoolId?: number | undefined;
  childPreferredSchoolName?: string | undefined;
  childPreferredServiceId?: number | undefined;
  childPreferredServiceName?: string | undefined;
  isExcluded?: boolean | undefined;
  rollMarkingTimeIn?: dayjs.Dayjs | undefined;
  rollMarkingTimeOut?: dayjs.Dayjs | undefined;
}

export class ChildConfirmationHttpResponse implements IChildConfirmationHttpResponse {
  childId!: number;
  firstName!: string;
  surname!: string;
  confirmationStatus!: number;

  constructor(data?: IChildConfirmationHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.firstName = _data["firstName"];
      this.surname = _data["surname"];
      this.confirmationStatus = _data["confirmationStatus"];
    }
  }

  static fromJS(data: any): ChildConfirmationHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ChildConfirmationHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["firstName"] = this.firstName;
    data["surname"] = this.surname;
    data["confirmationStatus"] = this.confirmationStatus;
    return data;
  }
}

export interface IChildConfirmationHttpResponse {
  childId: number;
  firstName: string;
  surname: string;
  confirmationStatus: number;
}

export class ChildAtSchoolStatusHttpResponse implements IChildAtSchoolStatusHttpResponse {
  id!: number;
  name!: string;
  description!: string;

  constructor(data?: IChildAtSchoolStatusHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): ChildAtSchoolStatusHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new ChildAtSchoolStatusHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    return data;
  }
}

export interface IChildAtSchoolStatusHttpResponse {
  id: number;
  name: string;
  description: string;
}

export class SaveChildrenConfirmationsHttpRequest implements ISaveChildrenConfirmationsHttpRequest {
  serviceId!: number;
  childrenConfirmations!: ChildConfirmationRequest[];

  constructor(data?: ISaveChildrenConfirmationsHttpRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.childrenConfirmations = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      if (Array.isArray(_data["childrenConfirmations"])) {
        this.childrenConfirmations = [] as any;
        for (let item of _data["childrenConfirmations"])
          this.childrenConfirmations!.push(ChildConfirmationRequest.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SaveChildrenConfirmationsHttpRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveChildrenConfirmationsHttpRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    if (Array.isArray(this.childrenConfirmations)) {
      data["childrenConfirmations"] = [];
      for (let item of this.childrenConfirmations)
        data["childrenConfirmations"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISaveChildrenConfirmationsHttpRequest {
  serviceId: number;
  childrenConfirmations: ChildConfirmationRequest[];
}

export class ChildConfirmationRequest implements IChildConfirmationRequest {
  childId!: number;
  confirmationStatus!: number;

  constructor(data?: IChildConfirmationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.confirmationStatus = _data["confirmationStatus"];
    }
  }

  static fromJS(data: any): ChildConfirmationRequest {
    data = typeof data === "object" ? data : {};
    let result = new ChildConfirmationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["confirmationStatus"] = this.confirmationStatus;
    return data;
  }
}

export interface IChildConfirmationRequest {
  childId: number;
  confirmationStatus: number;
}

export class GetNewsResponse implements IGetNewsResponse {
  total!: number;
  data?: ContentDto[] | undefined;

  constructor(data?: IGetNewsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.total = _data["total"];
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"]) this.data!.push(ContentDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetNewsResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetNewsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["total"] = this.total;
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IGetNewsResponse {
  total: number;
  data?: ContentDto[] | undefined;
}

export class ContentDto implements IContentDto {
  id!: number;
  title?: string | undefined;
  body?: string | undefined;
  effectiveFrom?: dayjs.Dayjs | undefined;
  effectiveTo?: dayjs.Dayjs | undefined;
  isVisible!: boolean;
  contentLocation!: ContentLocationEnum;
  createdOn!: dayjs.Dayjs;
  modifiedOn?: dayjs.Dayjs | undefined;
  sortOrder!: number;

  constructor(data?: IContentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.body = _data["body"];
      this.effectiveFrom = _data["effectiveFrom"] ? dayjs(_data["effectiveFrom"].toString()) : (undefined as any);
      this.effectiveTo = _data["effectiveTo"] ? dayjs(_data["effectiveTo"].toString()) : (undefined as any);
      this.isVisible = _data["isVisible"];
      this.contentLocation = _data["contentLocation"];
      this.createdOn = _data["createdOn"] ? dayjs(_data["createdOn"].toString()) : (undefined as any);
      this.modifiedOn = _data["modifiedOn"] ? dayjs(_data["modifiedOn"].toString()) : (undefined as any);
      this.sortOrder = _data["sortOrder"];
    }
  }

  static fromJS(data: any): ContentDto {
    data = typeof data === "object" ? data : {};
    let result = new ContentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["body"] = this.body;
    data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : (undefined as any);
    data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : (undefined as any);
    data["isVisible"] = this.isVisible;
    data["contentLocation"] = this.contentLocation;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : (undefined as any);
    data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : (undefined as any);
    data["sortOrder"] = this.sortOrder;
    return data;
  }
}

export interface IContentDto {
  id: number;
  title?: string | undefined;
  body?: string | undefined;
  effectiveFrom?: dayjs.Dayjs | undefined;
  effectiveTo?: dayjs.Dayjs | undefined;
  isVisible: boolean;
  contentLocation: ContentLocationEnum;
  createdOn: dayjs.Dayjs;
  modifiedOn?: dayjs.Dayjs | undefined;
  sortOrder: number;
}

export enum ContentLocationEnum {
  ParentPortalFeeInformation = "parentPortalFeeInformation",
  PartnerPortalNews = "partnerPortalNews",
  OneTeamRecognition = "oneTeamRecognition",
  ParentPortalFaq = "parentPortalFaq",
}

export class SessionDashboardResponse implements ISessionDashboardResponse {
  children!: SessionDashboardChild[];
  educators!: SessionDashboardEducator[];

  constructor(data?: ISessionDashboardResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.children = [];
      this.educators = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["children"])) {
        this.children = [] as any;
        for (let item of _data["children"]) this.children!.push(SessionDashboardChild.fromJS(item));
      }
      if (Array.isArray(_data["educators"])) {
        this.educators = [] as any;
        for (let item of _data["educators"]) this.educators!.push(SessionDashboardEducator.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SessionDashboardResponse {
    data = typeof data === "object" ? data : {};
    let result = new SessionDashboardResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.children)) {
      data["children"] = [];
      for (let item of this.children) data["children"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.educators)) {
      data["educators"] = [];
      for (let item of this.educators) data["educators"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISessionDashboardResponse {
  children: SessionDashboardChild[];
  educators: SessionDashboardEducator[];
}

export class SessionDashboardChild implements ISessionDashboardChild {
  childId!: number;
  bookingId!: number;
  rollId!: number;
  sessionId!: number;
  firstName!: string;
  lastName!: string;
  zoneName?: string | undefined;
  zoneId?: number | undefined;
  customerAccountId!: number;
  primaryServiceId?: number | undefined;
  primaryServiceName?: string | undefined;
  childPreferredSchoolId?: number | undefined;
  childPreferredSchoolName?: string | undefined;
  childPreferredServiceId?: number | undefined;
  childPreferredServiceName?: string | undefined;
  gender?: string | undefined;
  parentFirstName?: string | undefined;
  parentLastName?: string | undefined;
  eventType?: string | undefined;
  eventTime?: dayjs.Dayjs | undefined;

  constructor(data?: ISessionDashboardChild) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.childId = _data["childId"];
      this.bookingId = _data["bookingId"];
      this.rollId = _data["rollId"];
      this.sessionId = _data["sessionId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.zoneName = _data["zoneName"];
      this.zoneId = _data["zoneId"];
      this.customerAccountId = _data["customerAccountId"];
      this.primaryServiceId = _data["primaryServiceId"];
      this.primaryServiceName = _data["primaryServiceName"];
      this.childPreferredSchoolId = _data["childPreferredSchoolId"];
      this.childPreferredSchoolName = _data["childPreferredSchoolName"];
      this.childPreferredServiceId = _data["childPreferredServiceId"];
      this.childPreferredServiceName = _data["childPreferredServiceName"];
      this.gender = _data["gender"];
      this.parentFirstName = _data["parentFirstName"];
      this.parentLastName = _data["parentLastName"];
      this.eventType = _data["eventType"];
      this.eventTime = _data["eventTime"] ? dayjs(_data["eventTime"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): SessionDashboardChild {
    data = typeof data === "object" ? data : {};
    let result = new SessionDashboardChild();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["childId"] = this.childId;
    data["bookingId"] = this.bookingId;
    data["rollId"] = this.rollId;
    data["sessionId"] = this.sessionId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["zoneName"] = this.zoneName;
    data["zoneId"] = this.zoneId;
    data["customerAccountId"] = this.customerAccountId;
    data["primaryServiceId"] = this.primaryServiceId;
    data["primaryServiceName"] = this.primaryServiceName;
    data["childPreferredSchoolId"] = this.childPreferredSchoolId;
    data["childPreferredSchoolName"] = this.childPreferredSchoolName;
    data["childPreferredServiceId"] = this.childPreferredServiceId;
    data["childPreferredServiceName"] = this.childPreferredServiceName;
    data["gender"] = this.gender;
    data["parentFirstName"] = this.parentFirstName;
    data["parentLastName"] = this.parentLastName;
    data["eventType"] = this.eventType;
    data["eventTime"] = this.eventTime ? this.eventTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    return data;
  }
}

export interface ISessionDashboardChild {
  childId: number;
  bookingId: number;
  rollId: number;
  sessionId: number;
  firstName: string;
  lastName: string;
  zoneName?: string | undefined;
  zoneId?: number | undefined;
  customerAccountId: number;
  primaryServiceId?: number | undefined;
  primaryServiceName?: string | undefined;
  childPreferredSchoolId?: number | undefined;
  childPreferredSchoolName?: string | undefined;
  childPreferredServiceId?: number | undefined;
  childPreferredServiceName?: string | undefined;
  gender?: string | undefined;
  parentFirstName?: string | undefined;
  parentLastName?: string | undefined;
  eventType?: string | undefined;
  eventTime?: dayjs.Dayjs | undefined;
}

export class SessionDashboardEducator implements ISessionDashboardEducator {
  employeeId!: number;
  employeeName!: string;
  initials!: string;
  positionName!: string;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  isInRatio!: boolean;
  wwccReferences!: WwccReference[];

  constructor(data?: ISessionDashboardEducator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.wwccReferences = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.employeeId = _data["employeeId"];
      this.employeeName = _data["employeeName"];
      this.initials = _data["initials"];
      this.positionName = _data["positionName"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.isInRatio = _data["isInRatio"];
      if (Array.isArray(_data["wwccReferences"])) {
        this.wwccReferences = [] as any;
        for (let item of _data["wwccReferences"]) this.wwccReferences!.push(WwccReference.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SessionDashboardEducator {
    data = typeof data === "object" ? data : {};
    let result = new SessionDashboardEducator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["employeeId"] = this.employeeId;
    data["employeeName"] = this.employeeName;
    data["initials"] = this.initials;
    data["positionName"] = this.positionName;
    data["startTime"] = this.startTime ? this.startTime.toISOString() : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.toISOString() : (undefined as any);
    data["isInRatio"] = this.isInRatio;
    if (Array.isArray(this.wwccReferences)) {
      data["wwccReferences"] = [];
      for (let item of this.wwccReferences) data["wwccReferences"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface ISessionDashboardEducator {
  employeeId: number;
  employeeName: string;
  initials: string;
  positionName: string;
  startTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  isInRatio: boolean;
  wwccReferences: WwccReference[];
}

export class WwccReference implements IWwccReference {
  reference?: string | undefined;
  state?: string | undefined;

  constructor(data?: IWwccReference) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reference = _data["reference"];
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): WwccReference {
    data = typeof data === "object" ? data : {};
    let result = new WwccReference();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["reference"] = this.reference;
    data["state"] = this.state;
    return data;
  }
}

export interface IWwccReference {
  reference?: string | undefined;
  state?: string | undefined;
}

export class EmployeePosition implements IEmployeePosition {
  employeeId!: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  positionId!: number;
  positionName?: string | undefined;
  wwccReferences?: WwccReference[] | undefined;

  constructor(data?: IEmployeePosition) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.employeeId = _data["employeeId"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.positionId = _data["positionId"];
      this.positionName = _data["positionName"];
      if (Array.isArray(_data["wwccReferences"])) {
        this.wwccReferences = [] as any;
        for (let item of _data["wwccReferences"]) this.wwccReferences!.push(WwccReference.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EmployeePosition {
    data = typeof data === "object" ? data : {};
    let result = new EmployeePosition();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["employeeId"] = this.employeeId;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["positionId"] = this.positionId;
    data["positionName"] = this.positionName;
    if (Array.isArray(this.wwccReferences)) {
      data["wwccReferences"] = [];
      for (let item of this.wwccReferences) data["wwccReferences"].push(item ? item.toJSON() : (undefined as any));
    }
    return data;
  }
}

export interface IEmployeePosition {
  employeeId: number;
  firstName?: string | undefined;
  lastName?: string | undefined;
  positionId: number;
  positionName?: string | undefined;
  wwccReferences?: WwccReference[] | undefined;
}

export class FeeInformationFlyerViewModel implements IFeeInformationFlyerViewModel {
  serviceInformationFlyer!: ServiceInformationFlyer;
  activeRolls!: RollExtendedModel[];
  feeQueries!: FeeQuery[];
  lastFeeQuery?: FeeQuery | undefined;
  principalResponseDueDate?: dayjs.Dayjs | undefined;
  parentCommunicationDate?: dayjs.Dayjs | undefined;
  effectiveFromDate?: dayjs.Dayjs | undefined;
  effectiveFromTerm?: string | undefined;
  showTermInEffectiveFrom!: boolean;
  lastYearCcsInfo?: CcsInformation | undefined;
  currentYearCcsInfo?: CcsInformation | undefined;

  constructor(data?: IFeeInformationFlyerViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.serviceInformationFlyer = new ServiceInformationFlyer();
      this.activeRolls = [];
      this.feeQueries = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceInformationFlyer = _data["serviceInformationFlyer"]
        ? ServiceInformationFlyer.fromJS(_data["serviceInformationFlyer"])
        : new ServiceInformationFlyer();
      if (Array.isArray(_data["activeRolls"])) {
        this.activeRolls = [] as any;
        for (let item of _data["activeRolls"]) this.activeRolls!.push(RollExtendedModel.fromJS(item));
      }
      if (Array.isArray(_data["feeQueries"])) {
        this.feeQueries = [] as any;
        for (let item of _data["feeQueries"]) this.feeQueries!.push(FeeQuery.fromJS(item));
      }
      this.lastFeeQuery = _data["lastFeeQuery"] ? FeeQuery.fromJS(_data["lastFeeQuery"]) : (undefined as any);
      this.principalResponseDueDate = _data["principalResponseDueDate"]
        ? dayjs(_data["principalResponseDueDate"].toString())
        : (undefined as any);
      this.parentCommunicationDate = _data["parentCommunicationDate"]
        ? dayjs(_data["parentCommunicationDate"].toString())
        : (undefined as any);
      this.effectiveFromDate = _data["effectiveFromDate"]
        ? dayjs(_data["effectiveFromDate"].toString())
        : (undefined as any);
      this.effectiveFromTerm = _data["effectiveFromTerm"];
      this.showTermInEffectiveFrom = _data["showTermInEffectiveFrom"];
      this.lastYearCcsInfo = _data["lastYearCcsInfo"]
        ? CcsInformation.fromJS(_data["lastYearCcsInfo"])
        : (undefined as any);
      this.currentYearCcsInfo = _data["currentYearCcsInfo"]
        ? CcsInformation.fromJS(_data["currentYearCcsInfo"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): FeeInformationFlyerViewModel {
    data = typeof data === "object" ? data : {};
    let result = new FeeInformationFlyerViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceInformationFlyer"] = this.serviceInformationFlyer
      ? this.serviceInformationFlyer.toJSON()
      : (undefined as any);
    if (Array.isArray(this.activeRolls)) {
      data["activeRolls"] = [];
      for (let item of this.activeRolls) data["activeRolls"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.feeQueries)) {
      data["feeQueries"] = [];
      for (let item of this.feeQueries) data["feeQueries"].push(item ? item.toJSON() : (undefined as any));
    }
    data["lastFeeQuery"] = this.lastFeeQuery ? this.lastFeeQuery.toJSON() : (undefined as any);
    data["principalResponseDueDate"] = this.principalResponseDueDate
      ? this.principalResponseDueDate.toISOString()
      : (undefined as any);
    data["parentCommunicationDate"] = this.parentCommunicationDate
      ? this.parentCommunicationDate.toISOString()
      : (undefined as any);
    data["effectiveFromDate"] = this.effectiveFromDate ? this.effectiveFromDate.toISOString() : (undefined as any);
    data["effectiveFromTerm"] = this.effectiveFromTerm;
    data["showTermInEffectiveFrom"] = this.showTermInEffectiveFrom;
    data["lastYearCcsInfo"] = this.lastYearCcsInfo ? this.lastYearCcsInfo.toJSON() : (undefined as any);
    data["currentYearCcsInfo"] = this.currentYearCcsInfo ? this.currentYearCcsInfo.toJSON() : (undefined as any);
    return data;
  }
}

export interface IFeeInformationFlyerViewModel {
  serviceInformationFlyer: ServiceInformationFlyer;
  activeRolls: RollExtendedModel[];
  feeQueries: FeeQuery[];
  lastFeeQuery?: FeeQuery | undefined;
  principalResponseDueDate?: dayjs.Dayjs | undefined;
  parentCommunicationDate?: dayjs.Dayjs | undefined;
  effectiveFromDate?: dayjs.Dayjs | undefined;
  effectiveFromTerm?: string | undefined;
  showTermInEffectiveFrom: boolean;
  lastYearCcsInfo?: CcsInformation | undefined;
  currentYearCcsInfo?: CcsInformation | undefined;
}

export class ServiceInformationFlyer implements IServiceInformationFlyer {
  serviceId!: number;
  serviceName?: string | undefined;
  clientId!: number;
  isFboService!: boolean;
  acceptOrAcknowledgeFee?: string | undefined;
  annualEnrolmentFee!: number;
  accessCode?: string | undefined;
  cancellationThresholdDays!: number;
  casualBookingCancellationThresholdDays!: number;
  minBookingFeeHours!: number;
  firstMinBookingsRequired!: number;
  cancelledInTimeCutoffDays!: number;
  earlyFeeCutoffDays!: number;
  ccbMaxPercentage!: number;
  currentFees?: ServiceFlyerFee | undefined;
  proposedFees?: ServiceFlyerFee | undefined;
  hasUnconfirmedTermDates!: boolean;
  hasAcceptedFees!: boolean;
  allowQuery!: boolean;
  mapImageSrc?: string | undefined;

  constructor(data?: IServiceInformationFlyer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.clientId = _data["clientId"];
      this.isFboService = _data["isFboService"];
      this.acceptOrAcknowledgeFee = _data["acceptOrAcknowledgeFee"];
      this.annualEnrolmentFee = _data["annualEnrolmentFee"];
      this.accessCode = _data["accessCode"];
      this.cancellationThresholdDays = _data["cancellationThresholdDays"];
      this.casualBookingCancellationThresholdDays = _data["casualBookingCancellationThresholdDays"];
      this.minBookingFeeHours = _data["minBookingFeeHours"];
      this.firstMinBookingsRequired = _data["firstMinBookingsRequired"];
      this.cancelledInTimeCutoffDays = _data["cancelledInTimeCutoffDays"];
      this.earlyFeeCutoffDays = _data["earlyFeeCutoffDays"];
      this.ccbMaxPercentage = _data["ccbMaxPercentage"];
      this.currentFees = _data["currentFees"] ? ServiceFlyerFee.fromJS(_data["currentFees"]) : (undefined as any);
      this.proposedFees = _data["proposedFees"] ? ServiceFlyerFee.fromJS(_data["proposedFees"]) : (undefined as any);
      this.hasUnconfirmedTermDates = _data["hasUnconfirmedTermDates"];
      this.hasAcceptedFees = _data["hasAcceptedFees"];
      this.allowQuery = _data["allowQuery"];
      this.mapImageSrc = _data["mapImageSrc"];
    }
  }

  static fromJS(data: any): ServiceInformationFlyer {
    data = typeof data === "object" ? data : {};
    let result = new ServiceInformationFlyer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["clientId"] = this.clientId;
    data["isFboService"] = this.isFboService;
    data["acceptOrAcknowledgeFee"] = this.acceptOrAcknowledgeFee;
    data["annualEnrolmentFee"] = this.annualEnrolmentFee;
    data["accessCode"] = this.accessCode;
    data["cancellationThresholdDays"] = this.cancellationThresholdDays;
    data["casualBookingCancellationThresholdDays"] = this.casualBookingCancellationThresholdDays;
    data["minBookingFeeHours"] = this.minBookingFeeHours;
    data["firstMinBookingsRequired"] = this.firstMinBookingsRequired;
    data["cancelledInTimeCutoffDays"] = this.cancelledInTimeCutoffDays;
    data["earlyFeeCutoffDays"] = this.earlyFeeCutoffDays;
    data["ccbMaxPercentage"] = this.ccbMaxPercentage;
    data["currentFees"] = this.currentFees ? this.currentFees.toJSON() : (undefined as any);
    data["proposedFees"] = this.proposedFees ? this.proposedFees.toJSON() : (undefined as any);
    data["hasUnconfirmedTermDates"] = this.hasUnconfirmedTermDates;
    data["hasAcceptedFees"] = this.hasAcceptedFees;
    data["allowQuery"] = this.allowQuery;
    data["mapImageSrc"] = this.mapImageSrc;
    return data;
  }
}

export interface IServiceInformationFlyer {
  serviceId: number;
  serviceName?: string | undefined;
  clientId: number;
  isFboService: boolean;
  acceptOrAcknowledgeFee?: string | undefined;
  annualEnrolmentFee: number;
  accessCode?: string | undefined;
  cancellationThresholdDays: number;
  casualBookingCancellationThresholdDays: number;
  minBookingFeeHours: number;
  firstMinBookingsRequired: number;
  cancelledInTimeCutoffDays: number;
  earlyFeeCutoffDays: number;
  ccbMaxPercentage: number;
  currentFees?: ServiceFlyerFee | undefined;
  proposedFees?: ServiceFlyerFee | undefined;
  hasUnconfirmedTermDates: boolean;
  hasAcceptedFees: boolean;
  allowQuery: boolean;
  mapImageSrc?: string | undefined;
}

export class ServiceFlyerFee implements IServiceFlyerFee {
  serviceId!: number;
  serviceName?: string | undefined;
  hostSchool!: boolean;
  requestedDate!: dayjs.Dayjs;
  allowFeeQuery!: boolean;
  annualFee?: number | undefined;
  feederSchools?: string | undefined;
  ascFeeId!: number;
  ascFeeName?: string | undefined;
  ascFeeAmount?: number | undefined;
  ascCasualFeeAmount?: number | undefined;
  ascOutofPocketLow?: number | undefined;
  ascOutofPocketHigh?: number | undefined;
  ascIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  ascIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  ascStartTime?: dayjs.Dayjs | undefined;
  ascEndTime?: dayjs.Dayjs | undefined;
  ascOpenDays!: number;
  ascConsistentOperatingHours!: boolean;
  ascElcFeeId!: number;
  ascElcFeeName?: string | undefined;
  ascElcFeeAmount?: number | undefined;
  ascElcCasualFeeAmount?: number | undefined;
  ascElcOutofPocketLow?: number | undefined;
  ascElcOutofPocketHigh?: number | undefined;
  ascelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  ascelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  ascElcStartTime?: dayjs.Dayjs | undefined;
  ascElcEndTime?: dayjs.Dayjs | undefined;
  ascElcOpenDays!: number;
  ascElcConsistentOperatingHours!: boolean;
  bscFeeId!: number;
  bscFeeName?: string | undefined;
  bscFeeAmount?: number | undefined;
  bscCasualFeeAmount?: number | undefined;
  bscOutofPocketLow?: number | undefined;
  bscOutofPocketHigh?: number | undefined;
  bscIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  bscIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  bscStartTime?: dayjs.Dayjs | undefined;
  bscEndTime?: dayjs.Dayjs | undefined;
  bscOpenDays!: number;
  bscConsistentOperatingHours!: boolean;
  bscElcFeeId!: number;
  bscElcFeeName?: string | undefined;
  bscElcFeeAmount?: number | undefined;
  bscElcCasualFeeAmount?: number | undefined;
  bscElcOutofPocketLow?: number | undefined;
  bscElcOutofPocketHigh?: number | undefined;
  bscelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  bscelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  bscElcStartTime?: dayjs.Dayjs | undefined;
  bscElcEndTime?: dayjs.Dayjs | undefined;
  bscElcOpenDays!: number;
  bscElcConsistentOperatingHours!: boolean;
  vacFeeId!: number;
  vacFeeName?: string | undefined;
  vacFeeAmount?: number | undefined;
  vacCasualFeeAmount?: number | undefined;
  vacOutofPocketLow?: number | undefined;
  vacOutofPocketHigh?: number | undefined;
  vacIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  vacIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  vacStartTime?: dayjs.Dayjs | undefined;
  vacEndTime?: dayjs.Dayjs | undefined;
  vacElcFeeId!: number;
  vacElcFeeName?: string | undefined;
  vacElcFeeAmount?: number | undefined;
  vacElcCasualFeeAmount?: number | undefined;
  vacElcOutofPocketLow?: number | undefined;
  vacElcOutofPocketHigh?: number | undefined;
  vacelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  vacelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  vacElcStartTime?: dayjs.Dayjs | undefined;
  vacElcEndTime?: dayjs.Dayjs | undefined;
  pfdFeeId!: number;
  pfdFeeName?: string | undefined;
  pfdFeeAmount?: number | undefined;
  pfdCasualFeeAmount?: number | undefined;
  pfdOutofPocketLow?: number | undefined;
  pfdOutofPocketHigh?: number | undefined;
  pfdIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdStartTime?: dayjs.Dayjs | undefined;
  pfdEndTime?: dayjs.Dayjs | undefined;
  pfdElcFeeId!: number;
  pfdElcFeeName?: string | undefined;
  pfdElcFeeAmount?: number | undefined;
  pfdElcCasualFeeAmount?: number | undefined;
  pfdElcOutofPocketLow?: number | undefined;
  pfdElcOutofPocketHigh?: number | undefined;
  pfdelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdElcStartTime?: dayjs.Dayjs | undefined;
  pfdElcEndTime?: dayjs.Dayjs | undefined;
  bscLowFeeAmount?: number | undefined;
  bscHighFeeAmount?: number | undefined;
  ascLowFeeAmount?: number | undefined;
  ascHighFeeAmount?: number | undefined;
  ascCasual24FeeAmount?: number | undefined;
  ascCasual0FeeAmount?: number | undefined;
  ascWalkInFeeAmount?: number | undefined;
  ascNoShowFeeAmount?: number | undefined;
  bscCasual24FeeAmount?: number | undefined;
  bscCasual0FeeAmount?: number | undefined;
  bscWalkInFeeAmount?: number | undefined;
  bscNoShowFeeAmount?: number | undefined;
  blueAnnualFee?: number | undefined;
  silverAnnualFee?: number | undefined;
  goldAnnualFee?: number | undefined;
  earlySchoolFinishFeePerHour?: number | undefined;
  latePickUpFeePerHour?: number | undefined;
  applyEarlyFinishFee!: boolean;

  constructor(data?: IServiceFlyerFee) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.serviceName = _data["serviceName"];
      this.hostSchool = _data["hostSchool"];
      this.requestedDate = _data["requestedDate"] ? dayjs(_data["requestedDate"].toString()) : (undefined as any);
      this.allowFeeQuery = _data["allowFeeQuery"];
      this.annualFee = _data["annualFee"];
      this.feederSchools = _data["feederSchools"];
      this.ascFeeId = _data["ascFeeId"];
      this.ascFeeName = _data["ascFeeName"];
      this.ascFeeAmount = _data["ascFeeAmount"];
      this.ascCasualFeeAmount = _data["ascCasualFeeAmount"];
      this.ascOutofPocketLow = _data["ascOutofPocketLow"];
      this.ascOutofPocketHigh = _data["ascOutofPocketHigh"];
      this.ascIncreaseSessionFeeAfterMaxSubsidy = _data["ascIncreaseSessionFeeAfterMaxSubsidy"];
      this.ascIncreasePerHourSessionFeeAfterMaxSubsidy = _data["ascIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.ascStartTime = _data["ascStartTime"] ? dayjs(_data["ascStartTime"].toString()) : (undefined as any);
      this.ascEndTime = _data["ascEndTime"] ? dayjs(_data["ascEndTime"].toString()) : (undefined as any);
      this.ascOpenDays = _data["ascOpenDays"];
      this.ascConsistentOperatingHours = _data["ascConsistentOperatingHours"];
      this.ascElcFeeId = _data["ascElcFeeId"];
      this.ascElcFeeName = _data["ascElcFeeName"];
      this.ascElcFeeAmount = _data["ascElcFeeAmount"];
      this.ascElcCasualFeeAmount = _data["ascElcCasualFeeAmount"];
      this.ascElcOutofPocketLow = _data["ascElcOutofPocketLow"];
      this.ascElcOutofPocketHigh = _data["ascElcOutofPocketHigh"];
      this.ascelcIncreaseSessionFeeAfterMaxSubsidy = _data["ascelcIncreaseSessionFeeAfterMaxSubsidy"];
      this.ascelcIncreasePerHourSessionFeeAfterMaxSubsidy = _data["ascelcIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.ascElcStartTime = _data["ascElcStartTime"] ? dayjs(_data["ascElcStartTime"].toString()) : (undefined as any);
      this.ascElcEndTime = _data["ascElcEndTime"] ? dayjs(_data["ascElcEndTime"].toString()) : (undefined as any);
      this.ascElcOpenDays = _data["ascElcOpenDays"];
      this.ascElcConsistentOperatingHours = _data["ascElcConsistentOperatingHours"];
      this.bscFeeId = _data["bscFeeId"];
      this.bscFeeName = _data["bscFeeName"];
      this.bscFeeAmount = _data["bscFeeAmount"];
      this.bscCasualFeeAmount = _data["bscCasualFeeAmount"];
      this.bscOutofPocketLow = _data["bscOutofPocketLow"];
      this.bscOutofPocketHigh = _data["bscOutofPocketHigh"];
      this.bscIncreaseSessionFeeAfterMaxSubsidy = _data["bscIncreaseSessionFeeAfterMaxSubsidy"];
      this.bscIncreasePerHourSessionFeeAfterMaxSubsidy = _data["bscIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.bscStartTime = _data["bscStartTime"] ? dayjs(_data["bscStartTime"].toString()) : (undefined as any);
      this.bscEndTime = _data["bscEndTime"] ? dayjs(_data["bscEndTime"].toString()) : (undefined as any);
      this.bscOpenDays = _data["bscOpenDays"];
      this.bscConsistentOperatingHours = _data["bscConsistentOperatingHours"];
      this.bscElcFeeId = _data["bscElcFeeId"];
      this.bscElcFeeName = _data["bscElcFeeName"];
      this.bscElcFeeAmount = _data["bscElcFeeAmount"];
      this.bscElcCasualFeeAmount = _data["bscElcCasualFeeAmount"];
      this.bscElcOutofPocketLow = _data["bscElcOutofPocketLow"];
      this.bscElcOutofPocketHigh = _data["bscElcOutofPocketHigh"];
      this.bscelcIncreaseSessionFeeAfterMaxSubsidy = _data["bscelcIncreaseSessionFeeAfterMaxSubsidy"];
      this.bscelcIncreasePerHourSessionFeeAfterMaxSubsidy = _data["bscelcIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.bscElcStartTime = _data["bscElcStartTime"] ? dayjs(_data["bscElcStartTime"].toString()) : (undefined as any);
      this.bscElcEndTime = _data["bscElcEndTime"] ? dayjs(_data["bscElcEndTime"].toString()) : (undefined as any);
      this.bscElcOpenDays = _data["bscElcOpenDays"];
      this.bscElcConsistentOperatingHours = _data["bscElcConsistentOperatingHours"];
      this.vacFeeId = _data["vacFeeId"];
      this.vacFeeName = _data["vacFeeName"];
      this.vacFeeAmount = _data["vacFeeAmount"];
      this.vacCasualFeeAmount = _data["vacCasualFeeAmount"];
      this.vacOutofPocketLow = _data["vacOutofPocketLow"];
      this.vacOutofPocketHigh = _data["vacOutofPocketHigh"];
      this.vacIncreaseSessionFeeAfterMaxSubsidy = _data["vacIncreaseSessionFeeAfterMaxSubsidy"];
      this.vacIncreasePerHourSessionFeeAfterMaxSubsidy = _data["vacIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.vacStartTime = _data["vacStartTime"] ? dayjs(_data["vacStartTime"].toString()) : (undefined as any);
      this.vacEndTime = _data["vacEndTime"] ? dayjs(_data["vacEndTime"].toString()) : (undefined as any);
      this.vacElcFeeId = _data["vacElcFeeId"];
      this.vacElcFeeName = _data["vacElcFeeName"];
      this.vacElcFeeAmount = _data["vacElcFeeAmount"];
      this.vacElcCasualFeeAmount = _data["vacElcCasualFeeAmount"];
      this.vacElcOutofPocketLow = _data["vacElcOutofPocketLow"];
      this.vacElcOutofPocketHigh = _data["vacElcOutofPocketHigh"];
      this.vacelcIncreaseSessionFeeAfterMaxSubsidy = _data["vacelcIncreaseSessionFeeAfterMaxSubsidy"];
      this.vacelcIncreasePerHourSessionFeeAfterMaxSubsidy = _data["vacelcIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.vacElcStartTime = _data["vacElcStartTime"] ? dayjs(_data["vacElcStartTime"].toString()) : (undefined as any);
      this.vacElcEndTime = _data["vacElcEndTime"] ? dayjs(_data["vacElcEndTime"].toString()) : (undefined as any);
      this.pfdFeeId = _data["pfdFeeId"];
      this.pfdFeeName = _data["pfdFeeName"];
      this.pfdFeeAmount = _data["pfdFeeAmount"];
      this.pfdCasualFeeAmount = _data["pfdCasualFeeAmount"];
      this.pfdOutofPocketLow = _data["pfdOutofPocketLow"];
      this.pfdOutofPocketHigh = _data["pfdOutofPocketHigh"];
      this.pfdIncreaseSessionFeeAfterMaxSubsidy = _data["pfdIncreaseSessionFeeAfterMaxSubsidy"];
      this.pfdIncreasePerHourSessionFeeAfterMaxSubsidy = _data["pfdIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.pfdStartTime = _data["pfdStartTime"] ? dayjs(_data["pfdStartTime"].toString()) : (undefined as any);
      this.pfdEndTime = _data["pfdEndTime"] ? dayjs(_data["pfdEndTime"].toString()) : (undefined as any);
      this.pfdElcFeeId = _data["pfdElcFeeId"];
      this.pfdElcFeeName = _data["pfdElcFeeName"];
      this.pfdElcFeeAmount = _data["pfdElcFeeAmount"];
      this.pfdElcCasualFeeAmount = _data["pfdElcCasualFeeAmount"];
      this.pfdElcOutofPocketLow = _data["pfdElcOutofPocketLow"];
      this.pfdElcOutofPocketHigh = _data["pfdElcOutofPocketHigh"];
      this.pfdelcIncreaseSessionFeeAfterMaxSubsidy = _data["pfdelcIncreaseSessionFeeAfterMaxSubsidy"];
      this.pfdelcIncreasePerHourSessionFeeAfterMaxSubsidy = _data["pfdelcIncreasePerHourSessionFeeAfterMaxSubsidy"];
      this.pfdElcStartTime = _data["pfdElcStartTime"] ? dayjs(_data["pfdElcStartTime"].toString()) : (undefined as any);
      this.pfdElcEndTime = _data["pfdElcEndTime"] ? dayjs(_data["pfdElcEndTime"].toString()) : (undefined as any);
      this.bscLowFeeAmount = _data["bscLowFeeAmount"];
      this.bscHighFeeAmount = _data["bscHighFeeAmount"];
      this.ascLowFeeAmount = _data["ascLowFeeAmount"];
      this.ascHighFeeAmount = _data["ascHighFeeAmount"];
      this.ascCasual24FeeAmount = _data["ascCasual24FeeAmount"];
      this.ascCasual0FeeAmount = _data["ascCasual0FeeAmount"];
      this.ascWalkInFeeAmount = _data["ascWalkInFeeAmount"];
      this.ascNoShowFeeAmount = _data["ascNoShowFeeAmount"];
      this.bscCasual24FeeAmount = _data["bscCasual24FeeAmount"];
      this.bscCasual0FeeAmount = _data["bscCasual0FeeAmount"];
      this.bscWalkInFeeAmount = _data["bscWalkInFeeAmount"];
      this.bscNoShowFeeAmount = _data["bscNoShowFeeAmount"];
      this.blueAnnualFee = _data["blueAnnualFee"];
      this.silverAnnualFee = _data["silverAnnualFee"];
      this.goldAnnualFee = _data["goldAnnualFee"];
      this.earlySchoolFinishFeePerHour = _data["earlySchoolFinishFeePerHour"];
      this.latePickUpFeePerHour = _data["latePickUpFeePerHour"];
      this.applyEarlyFinishFee = _data["applyEarlyFinishFee"];
    }
  }

  static fromJS(data: any): ServiceFlyerFee {
    data = typeof data === "object" ? data : {};
    let result = new ServiceFlyerFee();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["serviceName"] = this.serviceName;
    data["hostSchool"] = this.hostSchool;
    data["requestedDate"] = this.requestedDate ? this.requestedDate.toISOString() : (undefined as any);
    data["allowFeeQuery"] = this.allowFeeQuery;
    data["annualFee"] = this.annualFee;
    data["feederSchools"] = this.feederSchools;
    data["ascFeeId"] = this.ascFeeId;
    data["ascFeeName"] = this.ascFeeName;
    data["ascFeeAmount"] = this.ascFeeAmount;
    data["ascCasualFeeAmount"] = this.ascCasualFeeAmount;
    data["ascOutofPocketLow"] = this.ascOutofPocketLow;
    data["ascOutofPocketHigh"] = this.ascOutofPocketHigh;
    data["ascIncreaseSessionFeeAfterMaxSubsidy"] = this.ascIncreaseSessionFeeAfterMaxSubsidy;
    data["ascIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.ascIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["ascStartTime"] = this.ascStartTime ? this.ascStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["ascEndTime"] = this.ascEndTime ? this.ascEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["ascOpenDays"] = this.ascOpenDays;
    data["ascConsistentOperatingHours"] = this.ascConsistentOperatingHours;
    data["ascElcFeeId"] = this.ascElcFeeId;
    data["ascElcFeeName"] = this.ascElcFeeName;
    data["ascElcFeeAmount"] = this.ascElcFeeAmount;
    data["ascElcCasualFeeAmount"] = this.ascElcCasualFeeAmount;
    data["ascElcOutofPocketLow"] = this.ascElcOutofPocketLow;
    data["ascElcOutofPocketHigh"] = this.ascElcOutofPocketHigh;
    data["ascelcIncreaseSessionFeeAfterMaxSubsidy"] = this.ascelcIncreaseSessionFeeAfterMaxSubsidy;
    data["ascelcIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.ascelcIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["ascElcStartTime"] = this.ascElcStartTime ? this.ascElcStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["ascElcEndTime"] = this.ascElcEndTime ? this.ascElcEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["ascElcOpenDays"] = this.ascElcOpenDays;
    data["ascElcConsistentOperatingHours"] = this.ascElcConsistentOperatingHours;
    data["bscFeeId"] = this.bscFeeId;
    data["bscFeeName"] = this.bscFeeName;
    data["bscFeeAmount"] = this.bscFeeAmount;
    data["bscCasualFeeAmount"] = this.bscCasualFeeAmount;
    data["bscOutofPocketLow"] = this.bscOutofPocketLow;
    data["bscOutofPocketHigh"] = this.bscOutofPocketHigh;
    data["bscIncreaseSessionFeeAfterMaxSubsidy"] = this.bscIncreaseSessionFeeAfterMaxSubsidy;
    data["bscIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.bscIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["bscStartTime"] = this.bscStartTime ? this.bscStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["bscEndTime"] = this.bscEndTime ? this.bscEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["bscOpenDays"] = this.bscOpenDays;
    data["bscConsistentOperatingHours"] = this.bscConsistentOperatingHours;
    data["bscElcFeeId"] = this.bscElcFeeId;
    data["bscElcFeeName"] = this.bscElcFeeName;
    data["bscElcFeeAmount"] = this.bscElcFeeAmount;
    data["bscElcCasualFeeAmount"] = this.bscElcCasualFeeAmount;
    data["bscElcOutofPocketLow"] = this.bscElcOutofPocketLow;
    data["bscElcOutofPocketHigh"] = this.bscElcOutofPocketHigh;
    data["bscelcIncreaseSessionFeeAfterMaxSubsidy"] = this.bscelcIncreaseSessionFeeAfterMaxSubsidy;
    data["bscelcIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.bscelcIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["bscElcStartTime"] = this.bscElcStartTime ? this.bscElcStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["bscElcEndTime"] = this.bscElcEndTime ? this.bscElcEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["bscElcOpenDays"] = this.bscElcOpenDays;
    data["bscElcConsistentOperatingHours"] = this.bscElcConsistentOperatingHours;
    data["vacFeeId"] = this.vacFeeId;
    data["vacFeeName"] = this.vacFeeName;
    data["vacFeeAmount"] = this.vacFeeAmount;
    data["vacCasualFeeAmount"] = this.vacCasualFeeAmount;
    data["vacOutofPocketLow"] = this.vacOutofPocketLow;
    data["vacOutofPocketHigh"] = this.vacOutofPocketHigh;
    data["vacIncreaseSessionFeeAfterMaxSubsidy"] = this.vacIncreaseSessionFeeAfterMaxSubsidy;
    data["vacIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.vacIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["vacStartTime"] = this.vacStartTime ? this.vacStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["vacEndTime"] = this.vacEndTime ? this.vacEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["vacElcFeeId"] = this.vacElcFeeId;
    data["vacElcFeeName"] = this.vacElcFeeName;
    data["vacElcFeeAmount"] = this.vacElcFeeAmount;
    data["vacElcCasualFeeAmount"] = this.vacElcCasualFeeAmount;
    data["vacElcOutofPocketLow"] = this.vacElcOutofPocketLow;
    data["vacElcOutofPocketHigh"] = this.vacElcOutofPocketHigh;
    data["vacelcIncreaseSessionFeeAfterMaxSubsidy"] = this.vacelcIncreaseSessionFeeAfterMaxSubsidy;
    data["vacelcIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.vacelcIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["vacElcStartTime"] = this.vacElcStartTime ? this.vacElcStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["vacElcEndTime"] = this.vacElcEndTime ? this.vacElcEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["pfdFeeId"] = this.pfdFeeId;
    data["pfdFeeName"] = this.pfdFeeName;
    data["pfdFeeAmount"] = this.pfdFeeAmount;
    data["pfdCasualFeeAmount"] = this.pfdCasualFeeAmount;
    data["pfdOutofPocketLow"] = this.pfdOutofPocketLow;
    data["pfdOutofPocketHigh"] = this.pfdOutofPocketHigh;
    data["pfdIncreaseSessionFeeAfterMaxSubsidy"] = this.pfdIncreaseSessionFeeAfterMaxSubsidy;
    data["pfdIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.pfdIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["pfdStartTime"] = this.pfdStartTime ? this.pfdStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["pfdEndTime"] = this.pfdEndTime ? this.pfdEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["pfdElcFeeId"] = this.pfdElcFeeId;
    data["pfdElcFeeName"] = this.pfdElcFeeName;
    data["pfdElcFeeAmount"] = this.pfdElcFeeAmount;
    data["pfdElcCasualFeeAmount"] = this.pfdElcCasualFeeAmount;
    data["pfdElcOutofPocketLow"] = this.pfdElcOutofPocketLow;
    data["pfdElcOutofPocketHigh"] = this.pfdElcOutofPocketHigh;
    data["pfdelcIncreaseSessionFeeAfterMaxSubsidy"] = this.pfdelcIncreaseSessionFeeAfterMaxSubsidy;
    data["pfdelcIncreasePerHourSessionFeeAfterMaxSubsidy"] = this.pfdelcIncreasePerHourSessionFeeAfterMaxSubsidy;
    data["pfdElcStartTime"] = this.pfdElcStartTime ? this.pfdElcStartTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["pfdElcEndTime"] = this.pfdElcEndTime ? this.pfdElcEndTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["bscLowFeeAmount"] = this.bscLowFeeAmount;
    data["bscHighFeeAmount"] = this.bscHighFeeAmount;
    data["ascLowFeeAmount"] = this.ascLowFeeAmount;
    data["ascHighFeeAmount"] = this.ascHighFeeAmount;
    data["ascCasual24FeeAmount"] = this.ascCasual24FeeAmount;
    data["ascCasual0FeeAmount"] = this.ascCasual0FeeAmount;
    data["ascWalkInFeeAmount"] = this.ascWalkInFeeAmount;
    data["ascNoShowFeeAmount"] = this.ascNoShowFeeAmount;
    data["bscCasual24FeeAmount"] = this.bscCasual24FeeAmount;
    data["bscCasual0FeeAmount"] = this.bscCasual0FeeAmount;
    data["bscWalkInFeeAmount"] = this.bscWalkInFeeAmount;
    data["bscNoShowFeeAmount"] = this.bscNoShowFeeAmount;
    data["blueAnnualFee"] = this.blueAnnualFee;
    data["silverAnnualFee"] = this.silverAnnualFee;
    data["goldAnnualFee"] = this.goldAnnualFee;
    data["earlySchoolFinishFeePerHour"] = this.earlySchoolFinishFeePerHour;
    data["latePickUpFeePerHour"] = this.latePickUpFeePerHour;
    data["applyEarlyFinishFee"] = this.applyEarlyFinishFee;
    return data;
  }
}

export interface IServiceFlyerFee {
  serviceId: number;
  serviceName?: string | undefined;
  hostSchool: boolean;
  requestedDate: dayjs.Dayjs;
  allowFeeQuery: boolean;
  annualFee?: number | undefined;
  feederSchools?: string | undefined;
  ascFeeId: number;
  ascFeeName?: string | undefined;
  ascFeeAmount?: number | undefined;
  ascCasualFeeAmount?: number | undefined;
  ascOutofPocketLow?: number | undefined;
  ascOutofPocketHigh?: number | undefined;
  ascIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  ascIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  ascStartTime?: dayjs.Dayjs | undefined;
  ascEndTime?: dayjs.Dayjs | undefined;
  ascOpenDays: number;
  ascConsistentOperatingHours: boolean;
  ascElcFeeId: number;
  ascElcFeeName?: string | undefined;
  ascElcFeeAmount?: number | undefined;
  ascElcCasualFeeAmount?: number | undefined;
  ascElcOutofPocketLow?: number | undefined;
  ascElcOutofPocketHigh?: number | undefined;
  ascelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  ascelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  ascElcStartTime?: dayjs.Dayjs | undefined;
  ascElcEndTime?: dayjs.Dayjs | undefined;
  ascElcOpenDays: number;
  ascElcConsistentOperatingHours: boolean;
  bscFeeId: number;
  bscFeeName?: string | undefined;
  bscFeeAmount?: number | undefined;
  bscCasualFeeAmount?: number | undefined;
  bscOutofPocketLow?: number | undefined;
  bscOutofPocketHigh?: number | undefined;
  bscIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  bscIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  bscStartTime?: dayjs.Dayjs | undefined;
  bscEndTime?: dayjs.Dayjs | undefined;
  bscOpenDays: number;
  bscConsistentOperatingHours: boolean;
  bscElcFeeId: number;
  bscElcFeeName?: string | undefined;
  bscElcFeeAmount?: number | undefined;
  bscElcCasualFeeAmount?: number | undefined;
  bscElcOutofPocketLow?: number | undefined;
  bscElcOutofPocketHigh?: number | undefined;
  bscelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  bscelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  bscElcStartTime?: dayjs.Dayjs | undefined;
  bscElcEndTime?: dayjs.Dayjs | undefined;
  bscElcOpenDays: number;
  bscElcConsistentOperatingHours: boolean;
  vacFeeId: number;
  vacFeeName?: string | undefined;
  vacFeeAmount?: number | undefined;
  vacCasualFeeAmount?: number | undefined;
  vacOutofPocketLow?: number | undefined;
  vacOutofPocketHigh?: number | undefined;
  vacIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  vacIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  vacStartTime?: dayjs.Dayjs | undefined;
  vacEndTime?: dayjs.Dayjs | undefined;
  vacElcFeeId: number;
  vacElcFeeName?: string | undefined;
  vacElcFeeAmount?: number | undefined;
  vacElcCasualFeeAmount?: number | undefined;
  vacElcOutofPocketLow?: number | undefined;
  vacElcOutofPocketHigh?: number | undefined;
  vacelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  vacelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  vacElcStartTime?: dayjs.Dayjs | undefined;
  vacElcEndTime?: dayjs.Dayjs | undefined;
  pfdFeeId: number;
  pfdFeeName?: string | undefined;
  pfdFeeAmount?: number | undefined;
  pfdCasualFeeAmount?: number | undefined;
  pfdOutofPocketLow?: number | undefined;
  pfdOutofPocketHigh?: number | undefined;
  pfdIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdStartTime?: dayjs.Dayjs | undefined;
  pfdEndTime?: dayjs.Dayjs | undefined;
  pfdElcFeeId: number;
  pfdElcFeeName?: string | undefined;
  pfdElcFeeAmount?: number | undefined;
  pfdElcCasualFeeAmount?: number | undefined;
  pfdElcOutofPocketLow?: number | undefined;
  pfdElcOutofPocketHigh?: number | undefined;
  pfdelcIncreaseSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdelcIncreasePerHourSessionFeeAfterMaxSubsidy?: number | undefined;
  pfdElcStartTime?: dayjs.Dayjs | undefined;
  pfdElcEndTime?: dayjs.Dayjs | undefined;
  bscLowFeeAmount?: number | undefined;
  bscHighFeeAmount?: number | undefined;
  ascLowFeeAmount?: number | undefined;
  ascHighFeeAmount?: number | undefined;
  ascCasual24FeeAmount?: number | undefined;
  ascCasual0FeeAmount?: number | undefined;
  ascWalkInFeeAmount?: number | undefined;
  ascNoShowFeeAmount?: number | undefined;
  bscCasual24FeeAmount?: number | undefined;
  bscCasual0FeeAmount?: number | undefined;
  bscWalkInFeeAmount?: number | undefined;
  bscNoShowFeeAmount?: number | undefined;
  blueAnnualFee?: number | undefined;
  silverAnnualFee?: number | undefined;
  goldAnnualFee?: number | undefined;
  earlySchoolFinishFeePerHour?: number | undefined;
  latePickUpFeePerHour?: number | undefined;
  applyEarlyFinishFee: boolean;
}

export class RollExtendedModel implements IRollExtendedModel {
  rollId!: number;
  active!: boolean;
  availabilityId!: number;
  sessionTypeId!: number;
  rollClassificationId?: number | undefined;
  rollName?: string | undefined;
  govCareTypeId!: number;
  govCareTypeCode?: string | undefined;
  govCareTypeDescription?: string | undefined;
  sessionTypeDeleted!: boolean;
  labourCareTypeId!: number;
  labourCareTypeDescription?: string | undefined;
  serviceId!: number;
  shortName?: string | undefined;
  serviceStatusId!: number;
  earliestOpenTime?: dayjs.Dayjs | undefined;
  latestOpenTime?: dayjs.Dayjs | undefined;
  latestClosingTime?: dayjs.Dayjs | undefined;
  earliestClosingTime?: dayjs.Dayjs | undefined;
  monIsOpen?: boolean | undefined;
  tueIsOpen?: boolean | undefined;
  wedIsOpen?: boolean | undefined;
  thuIsOpen?: boolean | undefined;
  friIsOpen?: boolean | undefined;
  satIsOpen?: boolean | undefined;
  sunIsOpen?: boolean | undefined;
  monStart?: dayjs.Dayjs | undefined;
  tueStart?: dayjs.Dayjs | undefined;
  wedStart?: dayjs.Dayjs | undefined;
  thuStart?: dayjs.Dayjs | undefined;
  friStart?: dayjs.Dayjs | undefined;
  satStart?: dayjs.Dayjs | undefined;
  sunStart?: dayjs.Dayjs | undefined;
  monEnd?: dayjs.Dayjs | undefined;
  tueEnd?: dayjs.Dayjs | undefined;
  wedEnd?: dayjs.Dayjs | undefined;
  thuEnd?: dayjs.Dayjs | undefined;
  friEnd?: dayjs.Dayjs | undefined;
  satEnd?: dayjs.Dayjs | undefined;
  sunEnd?: dayjs.Dayjs | undefined;
  licensedPlaces?: number | undefined;
  licensedPlacesWithoutOperationalCapacityCap?: number | undefined;
  operationalCapacity?: number | undefined;
  defaultCasualFeeId!: number;
  defaultCasualFeeName?: string | undefined;
  defaultCasualFeeAmount!: number;
  defaultPermFeeId!: number;
  defaultPermFeeName?: string | undefined;
  defaultPermFeeAmount?: number | undefined;
  effectiveFrom?: dayjs.Dayjs | undefined;
  effectiveTo?: dayjs.Dayjs | undefined;
  usesOshcFeeStructure?: boolean | undefined;
  minAgeMths!: number;
  maxAgeMths!: number;
  currentLDCChildrenPerEducator?: number | undefined;
  allowELCBookings!: boolean;
  daysOpen?: number | undefined;
  ageCalculationMethodId!: number;
  stateDefaultMinAge!: number;
  stateDefaultMaxAge!: number;
  stateDefaultELCMinAge!: number;
  defaultMinAgeMths!: number;
  defaultMaxAgeMths!: number;

  constructor(data?: IRollExtendedModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.active = _data["active"];
      this.availabilityId = _data["availabilityId"];
      this.sessionTypeId = _data["sessionTypeId"];
      this.rollClassificationId = _data["rollClassificationId"];
      this.rollName = _data["rollName"];
      this.govCareTypeId = _data["govCareTypeId"];
      this.govCareTypeCode = _data["govCareTypeCode"];
      this.govCareTypeDescription = _data["govCareTypeDescription"];
      this.sessionTypeDeleted = _data["sessionTypeDeleted"];
      this.labourCareTypeId = _data["labourCareTypeId"];
      this.labourCareTypeDescription = _data["labourCareTypeDescription"];
      this.serviceId = _data["serviceId"];
      this.shortName = _data["shortName"];
      this.serviceStatusId = _data["serviceStatusId"];
      this.earliestOpenTime = _data["earliestOpenTime"]
        ? dayjs(_data["earliestOpenTime"].toString())
        : (undefined as any);
      this.latestOpenTime = _data["latestOpenTime"] ? dayjs(_data["latestOpenTime"].toString()) : (undefined as any);
      this.latestClosingTime = _data["latestClosingTime"]
        ? dayjs(_data["latestClosingTime"].toString())
        : (undefined as any);
      this.earliestClosingTime = _data["earliestClosingTime"]
        ? dayjs(_data["earliestClosingTime"].toString())
        : (undefined as any);
      this.monIsOpen = _data["monIsOpen"];
      this.tueIsOpen = _data["tueIsOpen"];
      this.wedIsOpen = _data["wedIsOpen"];
      this.thuIsOpen = _data["thuIsOpen"];
      this.friIsOpen = _data["friIsOpen"];
      this.satIsOpen = _data["satIsOpen"];
      this.sunIsOpen = _data["sunIsOpen"];
      this.monStart = _data["monStart"] ? dayjs(_data["monStart"].toString()) : (undefined as any);
      this.tueStart = _data["tueStart"] ? dayjs(_data["tueStart"].toString()) : (undefined as any);
      this.wedStart = _data["wedStart"] ? dayjs(_data["wedStart"].toString()) : (undefined as any);
      this.thuStart = _data["thuStart"] ? dayjs(_data["thuStart"].toString()) : (undefined as any);
      this.friStart = _data["friStart"] ? dayjs(_data["friStart"].toString()) : (undefined as any);
      this.satStart = _data["satStart"] ? dayjs(_data["satStart"].toString()) : (undefined as any);
      this.sunStart = _data["sunStart"] ? dayjs(_data["sunStart"].toString()) : (undefined as any);
      this.monEnd = _data["monEnd"] ? dayjs(_data["monEnd"].toString()) : (undefined as any);
      this.tueEnd = _data["tueEnd"] ? dayjs(_data["tueEnd"].toString()) : (undefined as any);
      this.wedEnd = _data["wedEnd"] ? dayjs(_data["wedEnd"].toString()) : (undefined as any);
      this.thuEnd = _data["thuEnd"] ? dayjs(_data["thuEnd"].toString()) : (undefined as any);
      this.friEnd = _data["friEnd"] ? dayjs(_data["friEnd"].toString()) : (undefined as any);
      this.satEnd = _data["satEnd"] ? dayjs(_data["satEnd"].toString()) : (undefined as any);
      this.sunEnd = _data["sunEnd"] ? dayjs(_data["sunEnd"].toString()) : (undefined as any);
      this.licensedPlaces = _data["licensedPlaces"];
      this.licensedPlacesWithoutOperationalCapacityCap = _data["licensedPlacesWithoutOperationalCapacityCap"];
      this.operationalCapacity = _data["operationalCapacity"];
      this.defaultCasualFeeId = _data["defaultCasualFeeId"];
      this.defaultCasualFeeName = _data["defaultCasualFeeName"];
      this.defaultCasualFeeAmount = _data["defaultCasualFeeAmount"];
      this.defaultPermFeeId = _data["defaultPermFeeId"];
      this.defaultPermFeeName = _data["defaultPermFeeName"];
      this.defaultPermFeeAmount = _data["defaultPermFeeAmount"];
      this.effectiveFrom = _data["effectiveFrom"] ? dayjs(_data["effectiveFrom"].toString()) : (undefined as any);
      this.effectiveTo = _data["effectiveTo"] ? dayjs(_data["effectiveTo"].toString()) : (undefined as any);
      this.usesOshcFeeStructure = _data["usesOshcFeeStructure"];
      this.minAgeMths = _data["minAgeMths"];
      this.maxAgeMths = _data["maxAgeMths"];
      this.currentLDCChildrenPerEducator = _data["currentLDCChildrenPerEducator"];
      this.allowELCBookings = _data["allowELCBookings"];
      this.daysOpen = _data["daysOpen"];
      this.ageCalculationMethodId = _data["ageCalculationMethodId"];
      this.stateDefaultMinAge = _data["stateDefaultMinAge"];
      this.stateDefaultMaxAge = _data["stateDefaultMaxAge"];
      this.stateDefaultELCMinAge = _data["stateDefaultELCMinAge"];
      this.defaultMinAgeMths = _data["defaultMinAgeMths"];
      this.defaultMaxAgeMths = _data["defaultMaxAgeMths"];
    }
  }

  static fromJS(data: any): RollExtendedModel {
    data = typeof data === "object" ? data : {};
    let result = new RollExtendedModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["active"] = this.active;
    data["availabilityId"] = this.availabilityId;
    data["sessionTypeId"] = this.sessionTypeId;
    data["rollClassificationId"] = this.rollClassificationId;
    data["rollName"] = this.rollName;
    data["govCareTypeId"] = this.govCareTypeId;
    data["govCareTypeCode"] = this.govCareTypeCode;
    data["govCareTypeDescription"] = this.govCareTypeDescription;
    data["sessionTypeDeleted"] = this.sessionTypeDeleted;
    data["labourCareTypeId"] = this.labourCareTypeId;
    data["labourCareTypeDescription"] = this.labourCareTypeDescription;
    data["serviceId"] = this.serviceId;
    data["shortName"] = this.shortName;
    data["serviceStatusId"] = this.serviceStatusId;
    data["earliestOpenTime"] = this.earliestOpenTime
      ? this.earliestOpenTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["latestOpenTime"] = this.latestOpenTime ? this.latestOpenTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["latestClosingTime"] = this.latestClosingTime
      ? this.latestClosingTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["earliestClosingTime"] = this.earliestClosingTime
      ? this.earliestClosingTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["monIsOpen"] = this.monIsOpen;
    data["tueIsOpen"] = this.tueIsOpen;
    data["wedIsOpen"] = this.wedIsOpen;
    data["thuIsOpen"] = this.thuIsOpen;
    data["friIsOpen"] = this.friIsOpen;
    data["satIsOpen"] = this.satIsOpen;
    data["sunIsOpen"] = this.sunIsOpen;
    data["monStart"] = this.monStart ? this.monStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["tueStart"] = this.tueStart ? this.tueStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["wedStart"] = this.wedStart ? this.wedStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["thuStart"] = this.thuStart ? this.thuStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["friStart"] = this.friStart ? this.friStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["satStart"] = this.satStart ? this.satStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["sunStart"] = this.sunStart ? this.sunStart.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["monEnd"] = this.monEnd ? this.monEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["tueEnd"] = this.tueEnd ? this.tueEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["wedEnd"] = this.wedEnd ? this.wedEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["thuEnd"] = this.thuEnd ? this.thuEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["friEnd"] = this.friEnd ? this.friEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["satEnd"] = this.satEnd ? this.satEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["sunEnd"] = this.sunEnd ? this.sunEnd.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["licensedPlaces"] = this.licensedPlaces;
    data["licensedPlacesWithoutOperationalCapacityCap"] = this.licensedPlacesWithoutOperationalCapacityCap;
    data["operationalCapacity"] = this.operationalCapacity;
    data["defaultCasualFeeId"] = this.defaultCasualFeeId;
    data["defaultCasualFeeName"] = this.defaultCasualFeeName;
    data["defaultCasualFeeAmount"] = this.defaultCasualFeeAmount;
    data["defaultPermFeeId"] = this.defaultPermFeeId;
    data["defaultPermFeeName"] = this.defaultPermFeeName;
    data["defaultPermFeeAmount"] = this.defaultPermFeeAmount;
    data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : (undefined as any);
    data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : (undefined as any);
    data["usesOshcFeeStructure"] = this.usesOshcFeeStructure;
    data["minAgeMths"] = this.minAgeMths;
    data["maxAgeMths"] = this.maxAgeMths;
    data["currentLDCChildrenPerEducator"] = this.currentLDCChildrenPerEducator;
    data["allowELCBookings"] = this.allowELCBookings;
    data["daysOpen"] = this.daysOpen;
    data["ageCalculationMethodId"] = this.ageCalculationMethodId;
    data["stateDefaultMinAge"] = this.stateDefaultMinAge;
    data["stateDefaultMaxAge"] = this.stateDefaultMaxAge;
    data["stateDefaultELCMinAge"] = this.stateDefaultELCMinAge;
    data["defaultMinAgeMths"] = this.defaultMinAgeMths;
    data["defaultMaxAgeMths"] = this.defaultMaxAgeMths;
    return data;
  }
}

export interface IRollExtendedModel {
  rollId: number;
  active: boolean;
  availabilityId: number;
  sessionTypeId: number;
  rollClassificationId?: number | undefined;
  rollName?: string | undefined;
  govCareTypeId: number;
  govCareTypeCode?: string | undefined;
  govCareTypeDescription?: string | undefined;
  sessionTypeDeleted: boolean;
  labourCareTypeId: number;
  labourCareTypeDescription?: string | undefined;
  serviceId: number;
  shortName?: string | undefined;
  serviceStatusId: number;
  earliestOpenTime?: dayjs.Dayjs | undefined;
  latestOpenTime?: dayjs.Dayjs | undefined;
  latestClosingTime?: dayjs.Dayjs | undefined;
  earliestClosingTime?: dayjs.Dayjs | undefined;
  monIsOpen?: boolean | undefined;
  tueIsOpen?: boolean | undefined;
  wedIsOpen?: boolean | undefined;
  thuIsOpen?: boolean | undefined;
  friIsOpen?: boolean | undefined;
  satIsOpen?: boolean | undefined;
  sunIsOpen?: boolean | undefined;
  monStart?: dayjs.Dayjs | undefined;
  tueStart?: dayjs.Dayjs | undefined;
  wedStart?: dayjs.Dayjs | undefined;
  thuStart?: dayjs.Dayjs | undefined;
  friStart?: dayjs.Dayjs | undefined;
  satStart?: dayjs.Dayjs | undefined;
  sunStart?: dayjs.Dayjs | undefined;
  monEnd?: dayjs.Dayjs | undefined;
  tueEnd?: dayjs.Dayjs | undefined;
  wedEnd?: dayjs.Dayjs | undefined;
  thuEnd?: dayjs.Dayjs | undefined;
  friEnd?: dayjs.Dayjs | undefined;
  satEnd?: dayjs.Dayjs | undefined;
  sunEnd?: dayjs.Dayjs | undefined;
  licensedPlaces?: number | undefined;
  licensedPlacesWithoutOperationalCapacityCap?: number | undefined;
  operationalCapacity?: number | undefined;
  defaultCasualFeeId: number;
  defaultCasualFeeName?: string | undefined;
  defaultCasualFeeAmount: number;
  defaultPermFeeId: number;
  defaultPermFeeName?: string | undefined;
  defaultPermFeeAmount?: number | undefined;
  effectiveFrom?: dayjs.Dayjs | undefined;
  effectiveTo?: dayjs.Dayjs | undefined;
  usesOshcFeeStructure?: boolean | undefined;
  minAgeMths: number;
  maxAgeMths: number;
  currentLDCChildrenPerEducator?: number | undefined;
  allowELCBookings: boolean;
  daysOpen?: number | undefined;
  ageCalculationMethodId: number;
  stateDefaultMinAge: number;
  stateDefaultMaxAge: number;
  stateDefaultELCMinAge: number;
  defaultMinAgeMths: number;
  defaultMaxAgeMths: number;
}

export class FeeQuery implements IFeeQuery {
  feeQueryId!: number;
  serviceId!: number;
  schoolContactId?: number | undefined;
  currentBscFeeId?: number | undefined;
  currentBscAmount?: number | undefined;
  currentAscFeeId?: number | undefined;
  currentAscAmount?: number | undefined;
  proposedBscFeeId?: number | undefined;
  proposedBscAmount?: number | undefined;
  proposedAscFeeId?: number | undefined;
  proposedAscAmount?: number | undefined;
  comment?: string | undefined;
  isAccepted!: boolean;
  dateCreated!: dayjs.Dayjs;
  autoLoginKey?: string | undefined;
  currentVacFeeId?: number | undefined;
  currentVacAmount?: number | undefined;
  proposedVacFeeId?: number | undefined;
  proposedVacAmount?: number | undefined;
  isFboAccepted!: boolean;
  outcome?: string | undefined;
  actionedButton?: string | undefined;

  constructor(data?: IFeeQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.feeQueryId = _data["feeQueryId"];
      this.serviceId = _data["serviceId"];
      this.schoolContactId = _data["schoolContactId"];
      this.currentBscFeeId = _data["currentBscFeeId"];
      this.currentBscAmount = _data["currentBscAmount"];
      this.currentAscFeeId = _data["currentAscFeeId"];
      this.currentAscAmount = _data["currentAscAmount"];
      this.proposedBscFeeId = _data["proposedBscFeeId"];
      this.proposedBscAmount = _data["proposedBscAmount"];
      this.proposedAscFeeId = _data["proposedAscFeeId"];
      this.proposedAscAmount = _data["proposedAscAmount"];
      this.comment = _data["comment"];
      this.isAccepted = _data["isAccepted"];
      this.dateCreated = _data["dateCreated"] ? dayjs(_data["dateCreated"].toString()) : (undefined as any);
      this.autoLoginKey = _data["autoLoginKey"];
      this.currentVacFeeId = _data["currentVacFeeId"];
      this.currentVacAmount = _data["currentVacAmount"];
      this.proposedVacFeeId = _data["proposedVacFeeId"];
      this.proposedVacAmount = _data["proposedVacAmount"];
      this.isFboAccepted = _data["isFboAccepted"];
      this.outcome = _data["outcome"];
      this.actionedButton = _data["actionedButton"];
    }
  }

  static fromJS(data: any): FeeQuery {
    data = typeof data === "object" ? data : {};
    let result = new FeeQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["feeQueryId"] = this.feeQueryId;
    data["serviceId"] = this.serviceId;
    data["schoolContactId"] = this.schoolContactId;
    data["currentBscFeeId"] = this.currentBscFeeId;
    data["currentBscAmount"] = this.currentBscAmount;
    data["currentAscFeeId"] = this.currentAscFeeId;
    data["currentAscAmount"] = this.currentAscAmount;
    data["proposedBscFeeId"] = this.proposedBscFeeId;
    data["proposedBscAmount"] = this.proposedBscAmount;
    data["proposedAscFeeId"] = this.proposedAscFeeId;
    data["proposedAscAmount"] = this.proposedAscAmount;
    data["comment"] = this.comment;
    data["isAccepted"] = this.isAccepted;
    data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : (undefined as any);
    data["autoLoginKey"] = this.autoLoginKey;
    data["currentVacFeeId"] = this.currentVacFeeId;
    data["currentVacAmount"] = this.currentVacAmount;
    data["proposedVacFeeId"] = this.proposedVacFeeId;
    data["proposedVacAmount"] = this.proposedVacAmount;
    data["isFboAccepted"] = this.isFboAccepted;
    data["outcome"] = this.outcome;
    data["actionedButton"] = this.actionedButton;
    return data;
  }
}

export interface IFeeQuery {
  feeQueryId: number;
  serviceId: number;
  schoolContactId?: number | undefined;
  currentBscFeeId?: number | undefined;
  currentBscAmount?: number | undefined;
  currentAscFeeId?: number | undefined;
  currentAscAmount?: number | undefined;
  proposedBscFeeId?: number | undefined;
  proposedBscAmount?: number | undefined;
  proposedAscFeeId?: number | undefined;
  proposedAscAmount?: number | undefined;
  comment?: string | undefined;
  isAccepted: boolean;
  dateCreated: dayjs.Dayjs;
  autoLoginKey?: string | undefined;
  currentVacFeeId?: number | undefined;
  currentVacAmount?: number | undefined;
  proposedVacFeeId?: number | undefined;
  proposedVacAmount?: number | undefined;
  isFboAccepted: boolean;
  outcome?: string | undefined;
  actionedButton?: string | undefined;
}

export class CcsInformation implements ICcsInformation {
  maxCcsRate!: number;
  ccsHourlyRateCap!: number;
  effectiveFrom?: dayjs.Dayjs | undefined;
  effectiveTo?: dayjs.Dayjs | undefined;
  financialYearStarting!: number;
  financialYearEnding!: number;

  constructor(data?: ICcsInformation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.maxCcsRate = _data["maxCcsRate"];
      this.ccsHourlyRateCap = _data["ccsHourlyRateCap"];
      this.effectiveFrom = _data["effectiveFrom"] ? dayjs(_data["effectiveFrom"].toString()) : (undefined as any);
      this.effectiveTo = _data["effectiveTo"] ? dayjs(_data["effectiveTo"].toString()) : (undefined as any);
      this.financialYearStarting = _data["financialYearStarting"];
      this.financialYearEnding = _data["financialYearEnding"];
    }
  }

  static fromJS(data: any): CcsInformation {
    data = typeof data === "object" ? data : {};
    let result = new CcsInformation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["maxCcsRate"] = this.maxCcsRate;
    data["ccsHourlyRateCap"] = this.ccsHourlyRateCap;
    data["effectiveFrom"] = this.effectiveFrom ? this.effectiveFrom.toISOString() : (undefined as any);
    data["effectiveTo"] = this.effectiveTo ? this.effectiveTo.toISOString() : (undefined as any);
    data["financialYearStarting"] = this.financialYearStarting;
    data["financialYearEnding"] = this.financialYearEnding;
    return data;
  }
}

export interface ICcsInformation {
  maxCcsRate: number;
  ccsHourlyRateCap: number;
  effectiveFrom?: dayjs.Dayjs | undefined;
  effectiveTo?: dayjs.Dayjs | undefined;
  financialYearStarting: number;
  financialYearEnding: number;
}

export class FeePendingReviewResponse implements IFeePendingReviewResponse {
  hasPendingFees!: boolean;
  serviceId?: number | undefined;

  constructor(data?: IFeePendingReviewResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hasPendingFees = _data["hasPendingFees"];
      this.serviceId = _data["serviceId"];
    }
  }

  static fromJS(data: any): FeePendingReviewResponse {
    data = typeof data === "object" ? data : {};
    let result = new FeePendingReviewResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["hasPendingFees"] = this.hasPendingFees;
    data["serviceId"] = this.serviceId;
    return data;
  }
}

export interface IFeePendingReviewResponse {
  hasPendingFees: boolean;
  serviceId?: number | undefined;
}

export class FeeQuerySaveResponse implements IFeeQuerySaveResponse {
  isSuccess!: boolean;
  error?: string | undefined;
  resultObject?: FeeQuerySaveResponseResult | undefined;

  constructor(data?: IFeeQuerySaveResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isSuccess = _data["isSuccess"];
      this.error = _data["error"];
      this.resultObject = _data["resultObject"]
        ? FeeQuerySaveResponseResult.fromJS(_data["resultObject"])
        : (undefined as any);
    }
  }

  static fromJS(data: any): FeeQuerySaveResponse {
    data = typeof data === "object" ? data : {};
    let result = new FeeQuerySaveResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isSuccess"] = this.isSuccess;
    data["error"] = this.error;
    data["resultObject"] = this.resultObject ? this.resultObject.toJSON() : (undefined as any);
    return data;
  }
}

export interface IFeeQuerySaveResponse {
  isSuccess: boolean;
  error?: string | undefined;
  resultObject?: FeeQuerySaveResponseResult | undefined;
}

export class FeeQuerySaveResponseResult implements IFeeQuerySaveResponseResult {
  hasUnconfirmedTermDates!: boolean;

  constructor(data?: IFeeQuerySaveResponseResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.hasUnconfirmedTermDates = _data["hasUnconfirmedTermDates"];
    }
  }

  static fromJS(data: any): FeeQuerySaveResponseResult {
    data = typeof data === "object" ? data : {};
    let result = new FeeQuerySaveResponseResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["hasUnconfirmedTermDates"] = this.hasUnconfirmedTermDates;
    return data;
  }
}

export interface IFeeQuerySaveResponseResult {
  hasUnconfirmedTermDates: boolean;
}

export class FeeQuerySaveRequest implements IFeeQuerySaveRequest {
  query!: FeeQueryRequest;
  feeAction!: string;
  sendComms!: boolean;

  constructor(data?: IFeeQuerySaveRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.query = new FeeQueryRequest();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.query = _data["query"] ? FeeQueryRequest.fromJS(_data["query"]) : new FeeQueryRequest();
      this.feeAction = _data["feeAction"];
      this.sendComms = _data["sendComms"];
    }
  }

  static fromJS(data: any): FeeQuerySaveRequest {
    data = typeof data === "object" ? data : {};
    let result = new FeeQuerySaveRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["query"] = this.query ? this.query.toJSON() : (undefined as any);
    data["feeAction"] = this.feeAction;
    data["sendComms"] = this.sendComms;
    return data;
  }
}

export interface IFeeQuerySaveRequest {
  query: FeeQueryRequest;
  feeAction: string;
  sendComms: boolean;
}

export class FeeQueryRequest implements IFeeQueryRequest {
  schoolContactId?: number | undefined;
  currentBscFeeId?: number | undefined;
  currentBscAmount?: number | undefined;
  currentAscFeeId?: number | undefined;
  currentAscAmount?: number | undefined;
  proposedBscFeeId?: number | undefined;
  proposedBscAmount?: number | undefined;
  proposedAscFeeId?: number | undefined;
  proposedAscAmount?: number | undefined;
  comment?: string | undefined;
  isAccepted!: boolean;
  currentVacFeeId?: number | undefined;
  currentVacAmount?: number | undefined;
  proposedVacFeeId?: number | undefined;
  proposedVacAmount?: number | undefined;
  isFboAccepted!: boolean;

  constructor(data?: IFeeQueryRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolContactId = _data["schoolContactId"];
      this.currentBscFeeId = _data["currentBscFeeId"];
      this.currentBscAmount = _data["currentBscAmount"];
      this.currentAscFeeId = _data["currentAscFeeId"];
      this.currentAscAmount = _data["currentAscAmount"];
      this.proposedBscFeeId = _data["proposedBscFeeId"];
      this.proposedBscAmount = _data["proposedBscAmount"];
      this.proposedAscFeeId = _data["proposedAscFeeId"];
      this.proposedAscAmount = _data["proposedAscAmount"];
      this.comment = _data["comment"];
      this.isAccepted = _data["isAccepted"];
      this.currentVacFeeId = _data["currentVacFeeId"];
      this.currentVacAmount = _data["currentVacAmount"];
      this.proposedVacFeeId = _data["proposedVacFeeId"];
      this.proposedVacAmount = _data["proposedVacAmount"];
      this.isFboAccepted = _data["isFboAccepted"];
    }
  }

  static fromJS(data: any): FeeQueryRequest {
    data = typeof data === "object" ? data : {};
    let result = new FeeQueryRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["schoolContactId"] = this.schoolContactId;
    data["currentBscFeeId"] = this.currentBscFeeId;
    data["currentBscAmount"] = this.currentBscAmount;
    data["currentAscFeeId"] = this.currentAscFeeId;
    data["currentAscAmount"] = this.currentAscAmount;
    data["proposedBscFeeId"] = this.proposedBscFeeId;
    data["proposedBscAmount"] = this.proposedBscAmount;
    data["proposedAscFeeId"] = this.proposedAscFeeId;
    data["proposedAscAmount"] = this.proposedAscAmount;
    data["comment"] = this.comment;
    data["isAccepted"] = this.isAccepted;
    data["currentVacFeeId"] = this.currentVacFeeId;
    data["currentVacAmount"] = this.currentVacAmount;
    data["proposedVacFeeId"] = this.proposedVacFeeId;
    data["proposedVacAmount"] = this.proposedVacAmount;
    data["isFboAccepted"] = this.isFboAccepted;
    return data;
  }
}

export interface IFeeQueryRequest {
  schoolContactId?: number | undefined;
  currentBscFeeId?: number | undefined;
  currentBscAmount?: number | undefined;
  currentAscFeeId?: number | undefined;
  currentAscAmount?: number | undefined;
  proposedBscFeeId?: number | undefined;
  proposedBscAmount?: number | undefined;
  proposedAscFeeId?: number | undefined;
  proposedAscAmount?: number | undefined;
  comment?: string | undefined;
  isAccepted: boolean;
  currentVacFeeId?: number | undefined;
  currentVacAmount?: number | undefined;
  proposedVacFeeId?: number | undefined;
  proposedVacAmount?: number | undefined;
  isFboAccepted: boolean;
}

export class ProgramDateExtended implements IProgramDateExtended {
  programDateId!: number;
  programId!: number;
  date!: dayjs.Dayjs;
  description?: string | undefined;
  feeTypeId?: number | undefined;
  programActivityId?: number | undefined;
  overriddenSurcharge?: number | undefined;
  confirmedBy?: string | undefined;
  confirmedDate?: dayjs.Dayjs | undefined;
  isConfirmed?: boolean | undefined;
  restrictions?: string | undefined;
  serviceId!: number;
  rollId!: number;
  serviceShortName?: string | undefined;
  programName?: string | undefined;
  numberUnderneathMaximumToClose?: number | undefined;
  currentBookingNumbers?: number | undefined;
  maximumNumber?: number | undefined;
  isClosed?: boolean | undefined;
  surcharge?: number | undefined;
  isBeforeEarlyFeeCutoff?: boolean | undefined;
  amount?: number | undefined;
  feeDescription?: string | undefined;
  lateFee?: number | undefined;
  earlyBookingFeeDaysPrior?: number | undefined;
  localPermFeeEligibleCutoff?: dayjs.Dayjs | undefined;
  localTime?: dayjs.Dayjs | undefined;
  provider?: string | undefined;
  programActivityTypeId?: number | undefined;
  programGroupId?: number | undefined;
  excursionLeaveTime?: dayjs.Dayjs | undefined;
  excursionReturnTime?: dayjs.Dayjs | undefined;
  rosteredExcursionLeaveTime?: dayjs.Dayjs | undefined;
  rosteredExcursionReturnTime?: dayjs.Dayjs | undefined;
  beginTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  supplierActivityCode?: string | undefined;
  availableForBookings?: boolean | undefined;
  availableForWebBookings?: boolean | undefined;
  clientCodes?: string | undefined;
  isBusCombinedServices?: boolean | undefined;
  activityHeading?: string | undefined;
  activityTypeName?: string | undefined;

  constructor(data?: IProgramDateExtended) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.programDateId = _data["programDateId"];
      this.programId = _data["programId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.description = _data["description"];
      this.feeTypeId = _data["feeTypeId"];
      this.programActivityId = _data["programActivityId"];
      this.overriddenSurcharge = _data["overriddenSurcharge"];
      this.confirmedBy = _data["confirmedBy"];
      this.confirmedDate = _data["confirmedDate"] ? dayjs(_data["confirmedDate"].toString()) : (undefined as any);
      this.isConfirmed = _data["isConfirmed"];
      this.restrictions = _data["restrictions"];
      this.serviceId = _data["serviceId"];
      this.rollId = _data["rollId"];
      this.serviceShortName = _data["serviceShortName"];
      this.programName = _data["programName"];
      this.numberUnderneathMaximumToClose = _data["numberUnderneathMaximumToClose"];
      this.currentBookingNumbers = _data["currentBookingNumbers"];
      this.maximumNumber = _data["maximumNumber"];
      this.isClosed = _data["isClosed"];
      this.surcharge = _data["surcharge"];
      this.isBeforeEarlyFeeCutoff = _data["isBeforeEarlyFeeCutoff"];
      this.amount = _data["amount"];
      this.feeDescription = _data["feeDescription"];
      this.lateFee = _data["lateFee"];
      this.earlyBookingFeeDaysPrior = _data["earlyBookingFeeDaysPrior"];
      this.localPermFeeEligibleCutoff = _data["localPermFeeEligibleCutoff"]
        ? dayjs(_data["localPermFeeEligibleCutoff"].toString())
        : (undefined as any);
      this.localTime = _data["localTime"] ? dayjs(_data["localTime"].toString()) : (undefined as any);
      this.provider = _data["provider"];
      this.programActivityTypeId = _data["programActivityTypeId"];
      this.programGroupId = _data["programGroupId"];
      this.excursionLeaveTime = _data["excursionLeaveTime"]
        ? dayjs(_data["excursionLeaveTime"].toString())
        : (undefined as any);
      this.excursionReturnTime = _data["excursionReturnTime"]
        ? dayjs(_data["excursionReturnTime"].toString())
        : (undefined as any);
      this.rosteredExcursionLeaveTime = _data["rosteredExcursionLeaveTime"]
        ? dayjs(_data["rosteredExcursionLeaveTime"].toString())
        : (undefined as any);
      this.rosteredExcursionReturnTime = _data["rosteredExcursionReturnTime"]
        ? dayjs(_data["rosteredExcursionReturnTime"].toString())
        : (undefined as any);
      this.beginTime = _data["beginTime"] ? dayjs(_data["beginTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.supplierActivityCode = _data["supplierActivityCode"];
      this.availableForBookings = _data["availableForBookings"];
      this.availableForWebBookings = _data["availableForWebBookings"];
      this.clientCodes = _data["clientCodes"];
      this.isBusCombinedServices = _data["isBusCombinedServices"];
      this.activityHeading = _data["activityHeading"];
      this.activityTypeName = _data["activityTypeName"];
    }
  }

  static fromJS(data: any): ProgramDateExtended {
    data = typeof data === "object" ? data : {};
    let result = new ProgramDateExtended();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["programDateId"] = this.programDateId;
    data["programId"] = this.programId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["description"] = this.description;
    data["feeTypeId"] = this.feeTypeId;
    data["programActivityId"] = this.programActivityId;
    data["overriddenSurcharge"] = this.overriddenSurcharge;
    data["confirmedBy"] = this.confirmedBy;
    data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : (undefined as any);
    data["isConfirmed"] = this.isConfirmed;
    data["restrictions"] = this.restrictions;
    data["serviceId"] = this.serviceId;
    data["rollId"] = this.rollId;
    data["serviceShortName"] = this.serviceShortName;
    data["programName"] = this.programName;
    data["numberUnderneathMaximumToClose"] = this.numberUnderneathMaximumToClose;
    data["currentBookingNumbers"] = this.currentBookingNumbers;
    data["maximumNumber"] = this.maximumNumber;
    data["isClosed"] = this.isClosed;
    data["surcharge"] = this.surcharge;
    data["isBeforeEarlyFeeCutoff"] = this.isBeforeEarlyFeeCutoff;
    data["amount"] = this.amount;
    data["feeDescription"] = this.feeDescription;
    data["lateFee"] = this.lateFee;
    data["earlyBookingFeeDaysPrior"] = this.earlyBookingFeeDaysPrior;
    data["localPermFeeEligibleCutoff"] = this.localPermFeeEligibleCutoff
      ? this.localPermFeeEligibleCutoff.toISOString()
      : (undefined as any);
    data["localTime"] = this.localTime ? this.localTime.toISOString() : (undefined as any);
    data["provider"] = this.provider;
    data["programActivityTypeId"] = this.programActivityTypeId;
    data["programGroupId"] = this.programGroupId;
    data["excursionLeaveTime"] = this.excursionLeaveTime
      ? this.excursionLeaveTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["excursionReturnTime"] = this.excursionReturnTime
      ? this.excursionReturnTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["rosteredExcursionLeaveTime"] = this.rosteredExcursionLeaveTime
      ? this.rosteredExcursionLeaveTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["rosteredExcursionReturnTime"] = this.rosteredExcursionReturnTime
      ? this.rosteredExcursionReturnTime.format("d.hh:mm:ss.SSS")
      : (undefined as any);
    data["beginTime"] = this.beginTime ? this.beginTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["supplierActivityCode"] = this.supplierActivityCode;
    data["availableForBookings"] = this.availableForBookings;
    data["availableForWebBookings"] = this.availableForWebBookings;
    data["clientCodes"] = this.clientCodes;
    data["isBusCombinedServices"] = this.isBusCombinedServices;
    data["activityHeading"] = this.activityHeading;
    data["activityTypeName"] = this.activityTypeName;
    return data;
  }
}

export interface IProgramDateExtended {
  programDateId: number;
  programId: number;
  date: dayjs.Dayjs;
  description?: string | undefined;
  feeTypeId?: number | undefined;
  programActivityId?: number | undefined;
  overriddenSurcharge?: number | undefined;
  confirmedBy?: string | undefined;
  confirmedDate?: dayjs.Dayjs | undefined;
  isConfirmed?: boolean | undefined;
  restrictions?: string | undefined;
  serviceId: number;
  rollId: number;
  serviceShortName?: string | undefined;
  programName?: string | undefined;
  numberUnderneathMaximumToClose?: number | undefined;
  currentBookingNumbers?: number | undefined;
  maximumNumber?: number | undefined;
  isClosed?: boolean | undefined;
  surcharge?: number | undefined;
  isBeforeEarlyFeeCutoff?: boolean | undefined;
  amount?: number | undefined;
  feeDescription?: string | undefined;
  lateFee?: number | undefined;
  earlyBookingFeeDaysPrior?: number | undefined;
  localPermFeeEligibleCutoff?: dayjs.Dayjs | undefined;
  localTime?: dayjs.Dayjs | undefined;
  provider?: string | undefined;
  programActivityTypeId?: number | undefined;
  programGroupId?: number | undefined;
  excursionLeaveTime?: dayjs.Dayjs | undefined;
  excursionReturnTime?: dayjs.Dayjs | undefined;
  rosteredExcursionLeaveTime?: dayjs.Dayjs | undefined;
  rosteredExcursionReturnTime?: dayjs.Dayjs | undefined;
  beginTime?: dayjs.Dayjs | undefined;
  endTime?: dayjs.Dayjs | undefined;
  supplierActivityCode?: string | undefined;
  availableForBookings?: boolean | undefined;
  availableForWebBookings?: boolean | undefined;
  clientCodes?: string | undefined;
  isBusCombinedServices?: boolean | undefined;
  activityHeading?: string | undefined;
  activityTypeName?: string | undefined;
}

export class ConfirmAllDatesRequest implements IConfirmAllDatesRequest {
  userId!: string;
  year?: number | undefined;

  constructor(data?: IConfirmAllDatesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data["userId"];
      this.year = _data["year"];
    }
  }

  static fromJS(data: any): ConfirmAllDatesRequest {
    data = typeof data === "object" ? data : {};
    let result = new ConfirmAllDatesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["userId"] = this.userId;
    data["year"] = this.year;
    return data;
  }
}

export interface IConfirmAllDatesRequest {
  userId: string;
  year?: number | undefined;
}

export class SetRestrictionsRequest implements ISetRestrictionsRequest {
  restrictions?: string | undefined;

  constructor(data?: ISetRestrictionsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.restrictions = _data["restrictions"];
    }
  }

  static fromJS(data: any): SetRestrictionsRequest {
    data = typeof data === "object" ? data : {};
    let result = new SetRestrictionsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["restrictions"] = this.restrictions;
    return data;
  }
}

export interface ISetRestrictionsRequest {
  restrictions?: string | undefined;
}

export class KeyDatesViewModel implements IKeyDatesViewModel {
  confirmedTermDates!: DefaultTermDateHttpResponse[];
  defaultTermDates!: DefaultTermDateHttpResponse[];
  suggestedTermDates!: SuggestedTermDateHttpResponse[];
  pupilFreeDays!: PupilFreeDayHttpResponse[];
  suggestedPfds!: SuggestedPfdHttpResponse[];
  pfdServiceTypes!: PfdServiceTypeHttpResponse[];
  publicHolidays!: PublicHoliday[];
  year!: number;
  calendarStart!: number;
  calendarEnd!: number;
  currentYearTermsConfirmed!: boolean;

  constructor(data?: IKeyDatesViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.confirmedTermDates = [];
      this.defaultTermDates = [];
      this.suggestedTermDates = [];
      this.pupilFreeDays = [];
      this.suggestedPfds = [];
      this.pfdServiceTypes = [];
      this.publicHolidays = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["confirmedTermDates"])) {
        this.confirmedTermDates = [] as any;
        for (let item of _data["confirmedTermDates"])
          this.confirmedTermDates!.push(DefaultTermDateHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["defaultTermDates"])) {
        this.defaultTermDates = [] as any;
        for (let item of _data["defaultTermDates"])
          this.defaultTermDates!.push(DefaultTermDateHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["suggestedTermDates"])) {
        this.suggestedTermDates = [] as any;
        for (let item of _data["suggestedTermDates"])
          this.suggestedTermDates!.push(SuggestedTermDateHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["pupilFreeDays"])) {
        this.pupilFreeDays = [] as any;
        for (let item of _data["pupilFreeDays"]) this.pupilFreeDays!.push(PupilFreeDayHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["suggestedPfds"])) {
        this.suggestedPfds = [] as any;
        for (let item of _data["suggestedPfds"]) this.suggestedPfds!.push(SuggestedPfdHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["pfdServiceTypes"])) {
        this.pfdServiceTypes = [] as any;
        for (let item of _data["pfdServiceTypes"]) this.pfdServiceTypes!.push(PfdServiceTypeHttpResponse.fromJS(item));
      }
      if (Array.isArray(_data["publicHolidays"])) {
        this.publicHolidays = [] as any;
        for (let item of _data["publicHolidays"]) this.publicHolidays!.push(PublicHoliday.fromJS(item));
      }
      this.year = _data["year"];
      this.calendarStart = _data["calendarStart"];
      this.calendarEnd = _data["calendarEnd"];
      this.currentYearTermsConfirmed = _data["currentYearTermsConfirmed"];
    }
  }

  static fromJS(data: any): KeyDatesViewModel {
    data = typeof data === "object" ? data : {};
    let result = new KeyDatesViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.confirmedTermDates)) {
      data["confirmedTermDates"] = [];
      for (let item of this.confirmedTermDates)
        data["confirmedTermDates"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.defaultTermDates)) {
      data["defaultTermDates"] = [];
      for (let item of this.defaultTermDates) data["defaultTermDates"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.suggestedTermDates)) {
      data["suggestedTermDates"] = [];
      for (let item of this.suggestedTermDates)
        data["suggestedTermDates"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.pupilFreeDays)) {
      data["pupilFreeDays"] = [];
      for (let item of this.pupilFreeDays) data["pupilFreeDays"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.suggestedPfds)) {
      data["suggestedPfds"] = [];
      for (let item of this.suggestedPfds) data["suggestedPfds"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.pfdServiceTypes)) {
      data["pfdServiceTypes"] = [];
      for (let item of this.pfdServiceTypes) data["pfdServiceTypes"].push(item ? item.toJSON() : (undefined as any));
    }
    if (Array.isArray(this.publicHolidays)) {
      data["publicHolidays"] = [];
      for (let item of this.publicHolidays) data["publicHolidays"].push(item ? item.toJSON() : (undefined as any));
    }
    data["year"] = this.year;
    data["calendarStart"] = this.calendarStart;
    data["calendarEnd"] = this.calendarEnd;
    data["currentYearTermsConfirmed"] = this.currentYearTermsConfirmed;
    return data;
  }
}

export interface IKeyDatesViewModel {
  confirmedTermDates: DefaultTermDateHttpResponse[];
  defaultTermDates: DefaultTermDateHttpResponse[];
  suggestedTermDates: SuggestedTermDateHttpResponse[];
  pupilFreeDays: PupilFreeDayHttpResponse[];
  suggestedPfds: SuggestedPfdHttpResponse[];
  pfdServiceTypes: PfdServiceTypeHttpResponse[];
  publicHolidays: PublicHoliday[];
  year: number;
  calendarStart: number;
  calendarEnd: number;
  currentYearTermsConfirmed: boolean;
}

export class DefaultTermDateHttpResponse implements IDefaultTermDateHttpResponse {
  termDateId!: number;
  termNumber!: number;
  firstDayOfTerm!: dayjs.Dayjs;
  lastDayOfTerm!: dayjs.Dayjs;
  year!: number;
  state?: string | undefined;
  confirmedDate?: dayjs.Dayjs | undefined;

  constructor(data?: IDefaultTermDateHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termDateId = _data["termDateId"];
      this.termNumber = _data["termNumber"];
      this.firstDayOfTerm = _data["firstDayOfTerm"] ? dayjs(_data["firstDayOfTerm"].toString()) : (undefined as any);
      this.lastDayOfTerm = _data["lastDayOfTerm"] ? dayjs(_data["lastDayOfTerm"].toString()) : (undefined as any);
      this.year = _data["year"];
      this.state = _data["state"];
      this.confirmedDate = _data["confirmedDate"] ? dayjs(_data["confirmedDate"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): DefaultTermDateHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new DefaultTermDateHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termDateId"] = this.termDateId;
    data["termNumber"] = this.termNumber;
    data["firstDayOfTerm"] = this.firstDayOfTerm ? this.firstDayOfTerm.format("YYYY-MM-DD") : (undefined as any);
    data["lastDayOfTerm"] = this.lastDayOfTerm ? this.lastDayOfTerm.format("YYYY-MM-DD") : (undefined as any);
    data["year"] = this.year;
    data["state"] = this.state;
    data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : (undefined as any);
    return data;
  }
}

export interface IDefaultTermDateHttpResponse {
  termDateId: number;
  termNumber: number;
  firstDayOfTerm: dayjs.Dayjs;
  lastDayOfTerm: dayjs.Dayjs;
  year: number;
  state?: string | undefined;
  confirmedDate?: dayjs.Dayjs | undefined;
}

export class SuggestedTermDateHttpResponse implements ISuggestedTermDateHttpResponse {
  termDateSuggestionId!: number;
  serviceId!: number;
  termDateId!: number;
  termNumber!: number;
  firstDayOfTerm!: dayjs.Dayjs;
  lastDayOfTerm!: dayjs.Dayjs;
  suggestedBy!: string;
  suggestedDate!: dayjs.Dayjs;
  reason?: string | undefined;
  deletedOn?: dayjs.Dayjs | undefined;

  constructor(data?: ISuggestedTermDateHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termDateSuggestionId = _data["termDateSuggestionId"];
      this.serviceId = _data["serviceId"];
      this.termDateId = _data["termDateId"];
      this.termNumber = _data["termNumber"];
      this.firstDayOfTerm = _data["firstDayOfTerm"] ? dayjs(_data["firstDayOfTerm"].toString()) : (undefined as any);
      this.lastDayOfTerm = _data["lastDayOfTerm"] ? dayjs(_data["lastDayOfTerm"].toString()) : (undefined as any);
      this.suggestedBy = _data["suggestedBy"];
      this.suggestedDate = _data["suggestedDate"] ? dayjs(_data["suggestedDate"].toString()) : (undefined as any);
      this.reason = _data["reason"];
      this.deletedOn = _data["deletedOn"] ? dayjs(_data["deletedOn"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): SuggestedTermDateHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new SuggestedTermDateHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termDateSuggestionId"] = this.termDateSuggestionId;
    data["serviceId"] = this.serviceId;
    data["termDateId"] = this.termDateId;
    data["termNumber"] = this.termNumber;
    data["firstDayOfTerm"] = this.firstDayOfTerm ? this.firstDayOfTerm.format("YYYY-MM-DD") : (undefined as any);
    data["lastDayOfTerm"] = this.lastDayOfTerm ? this.lastDayOfTerm.format("YYYY-MM-DD") : (undefined as any);
    data["suggestedBy"] = this.suggestedBy;
    data["suggestedDate"] = this.suggestedDate ? this.suggestedDate.toISOString() : (undefined as any);
    data["reason"] = this.reason;
    data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface ISuggestedTermDateHttpResponse {
  termDateSuggestionId: number;
  serviceId: number;
  termDateId: number;
  termNumber: number;
  firstDayOfTerm: dayjs.Dayjs;
  lastDayOfTerm: dayjs.Dayjs;
  suggestedBy: string;
  suggestedDate: dayjs.Dayjs;
  reason?: string | undefined;
  deletedOn?: dayjs.Dayjs | undefined;
}

export class PupilFreeDayHttpResponse implements IPupilFreeDayHttpResponse {
  pupilFreeDayServiceId!: number;
  serviceId!: number;
  date!: dayjs.Dayjs;
  pupilFreeDayServiceTypeId!: number;
  pupilFreeDayServiceTypeName?: string | undefined;
  createdOn!: dayjs.Dayjs;
  deletedOn?: dayjs.Dayjs | undefined;

  constructor(data?: IPupilFreeDayHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pupilFreeDayServiceId = _data["pupilFreeDayServiceId"];
      this.serviceId = _data["serviceId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.pupilFreeDayServiceTypeId = _data["pupilFreeDayServiceTypeId"];
      this.pupilFreeDayServiceTypeName = _data["pupilFreeDayServiceTypeName"];
      this.createdOn = _data["createdOn"] ? dayjs(_data["createdOn"].toString()) : (undefined as any);
      this.deletedOn = _data["deletedOn"] ? dayjs(_data["deletedOn"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): PupilFreeDayHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new PupilFreeDayHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pupilFreeDayServiceId"] = this.pupilFreeDayServiceId;
    data["serviceId"] = this.serviceId;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    data["pupilFreeDayServiceTypeId"] = this.pupilFreeDayServiceTypeId;
    data["pupilFreeDayServiceTypeName"] = this.pupilFreeDayServiceTypeName;
    data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : (undefined as any);
    data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface IPupilFreeDayHttpResponse {
  pupilFreeDayServiceId: number;
  serviceId: number;
  date: dayjs.Dayjs;
  pupilFreeDayServiceTypeId: number;
  pupilFreeDayServiceTypeName?: string | undefined;
  createdOn: dayjs.Dayjs;
  deletedOn?: dayjs.Dayjs | undefined;
}

export class SuggestedPfdHttpResponse implements ISuggestedPfdHttpResponse {
  pupilFreeDaySuggestionId!: number;
  serviceId!: number;
  date!: dayjs.Dayjs;
  pupilFreeDayServiceTypeId!: number;
  pupilFreeDayServiceTypeName?: string | undefined;
  suggestedBy!: string;
  suggestedDate!: dayjs.Dayjs;
  deletedOn?: dayjs.Dayjs | undefined;

  constructor(data?: ISuggestedPfdHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pupilFreeDaySuggestionId = _data["pupilFreeDaySuggestionId"];
      this.serviceId = _data["serviceId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.pupilFreeDayServiceTypeId = _data["pupilFreeDayServiceTypeId"];
      this.pupilFreeDayServiceTypeName = _data["pupilFreeDayServiceTypeName"];
      this.suggestedBy = _data["suggestedBy"];
      this.suggestedDate = _data["suggestedDate"] ? dayjs(_data["suggestedDate"].toString()) : (undefined as any);
      this.deletedOn = _data["deletedOn"] ? dayjs(_data["deletedOn"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): SuggestedPfdHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new SuggestedPfdHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pupilFreeDaySuggestionId"] = this.pupilFreeDaySuggestionId;
    data["serviceId"] = this.serviceId;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    data["pupilFreeDayServiceTypeId"] = this.pupilFreeDayServiceTypeId;
    data["pupilFreeDayServiceTypeName"] = this.pupilFreeDayServiceTypeName;
    data["suggestedBy"] = this.suggestedBy;
    data["suggestedDate"] = this.suggestedDate ? this.suggestedDate.toISOString() : (undefined as any);
    data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : (undefined as any);
    return data;
  }
}

export interface ISuggestedPfdHttpResponse {
  pupilFreeDaySuggestionId: number;
  serviceId: number;
  date: dayjs.Dayjs;
  pupilFreeDayServiceTypeId: number;
  pupilFreeDayServiceTypeName?: string | undefined;
  suggestedBy: string;
  suggestedDate: dayjs.Dayjs;
  deletedOn?: dayjs.Dayjs | undefined;
}

export class PfdServiceTypeHttpResponse implements IPfdServiceTypeHttpResponse {
  pupilFreeDayServiceTypeId!: number;
  description!: string;

  constructor(data?: IPfdServiceTypeHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pupilFreeDayServiceTypeId = _data["pupilFreeDayServiceTypeId"];
      this.description = _data["description"];
    }
  }

  static fromJS(data: any): PfdServiceTypeHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new PfdServiceTypeHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pupilFreeDayServiceTypeId"] = this.pupilFreeDayServiceTypeId;
    data["description"] = this.description;
    return data;
  }
}

export interface IPfdServiceTypeHttpResponse {
  pupilFreeDayServiceTypeId: number;
  description: string;
}

export class PublicHoliday implements IPublicHoliday {
  publicHolidayId!: number;
  date!: dayjs.Dayjs;
  name!: string;
  state?: string | undefined;

  constructor(data?: IPublicHoliday) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.publicHolidayId = _data["publicHolidayId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.name = _data["name"];
      this.state = _data["state"];
    }
  }

  static fromJS(data: any): PublicHoliday {
    data = typeof data === "object" ? data : {};
    let result = new PublicHoliday();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["publicHolidayId"] = this.publicHolidayId;
    data["date"] = this.date ? this.date.format("YYYY-MM-DD") : (undefined as any);
    data["name"] = this.name;
    data["state"] = this.state;
    return data;
  }
}

export interface IPublicHoliday {
  publicHolidayId: number;
  date: dayjs.Dayjs;
  name: string;
  state?: string | undefined;
}

export class SuggestPfdRequest implements ISuggestPfdRequest {
  pfdDate!: dayjs.Dayjs;
  pfdServiceTypeId!: number;

  constructor(data?: ISuggestPfdRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pfdDate = _data["pfdDate"] ? dayjs(_data["pfdDate"].toString()) : (undefined as any);
      this.pfdServiceTypeId = _data["pfdServiceTypeId"];
    }
  }

  static fromJS(data: any): SuggestPfdRequest {
    data = typeof data === "object" ? data : {};
    let result = new SuggestPfdRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pfdDate"] = this.pfdDate ? this.pfdDate.format("YYYY-MM-DD") : (undefined as any);
    data["pfdServiceTypeId"] = this.pfdServiceTypeId;
    return data;
  }
}

export interface ISuggestPfdRequest {
  pfdDate: dayjs.Dayjs;
  pfdServiceTypeId: number;
}

export class SavePfdRequest implements ISavePfdRequest {
  pupilFreeDaySuggestionId!: number;
  date!: dayjs.Dayjs;
  serviceTypeId!: number;

  constructor(data?: ISavePfdRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pupilFreeDaySuggestionId = _data["pupilFreeDaySuggestionId"];
      this.date = _data["date"] ? dayjs(_data["date"].toString()) : (undefined as any);
      this.serviceTypeId = _data["serviceTypeId"];
    }
  }

  static fromJS(data: any): SavePfdRequest {
    data = typeof data === "object" ? data : {};
    let result = new SavePfdRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pupilFreeDaySuggestionId"] = this.pupilFreeDaySuggestionId;
    data["date"] = this.date ? this.date.toISOString() : (undefined as any);
    data["serviceTypeId"] = this.serviceTypeId;
    return data;
  }
}

export interface ISavePfdRequest {
  pupilFreeDaySuggestionId: number;
  date: dayjs.Dayjs;
  serviceTypeId: number;
}

export class SuggestTermDateRequest implements ISuggestTermDateRequest {
  termDateId!: number;
  startDate!: dayjs.Dayjs;
  endDate!: dayjs.Dayjs;
  termNumber!: number;
  reason?: string | undefined;

  constructor(data?: ISuggestTermDateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termDateId = _data["termDateId"];
      this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : (undefined as any);
      this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : (undefined as any);
      this.termNumber = _data["termNumber"];
      this.reason = _data["reason"];
    }
  }

  static fromJS(data: any): SuggestTermDateRequest {
    data = typeof data === "object" ? data : {};
    let result = new SuggestTermDateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termDateId"] = this.termDateId;
    data["startDate"] = this.startDate ? this.startDate.format("YYYY-MM-DD") : (undefined as any);
    data["endDate"] = this.endDate ? this.endDate.format("YYYY-MM-DD") : (undefined as any);
    data["termNumber"] = this.termNumber;
    data["reason"] = this.reason;
    return data;
  }
}

export interface ISuggestTermDateRequest {
  termDateId: number;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  termNumber: number;
  reason?: string | undefined;
}

export class EditSuggestedTermDateRequest implements IEditSuggestedTermDateRequest {
  termDateSuggestionId!: number;
  startDate!: dayjs.Dayjs;
  endDate!: dayjs.Dayjs;
  termNumber!: number;
  reason?: string | undefined;

  constructor(data?: IEditSuggestedTermDateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termDateSuggestionId = _data["termDateSuggestionId"];
      this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : (undefined as any);
      this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : (undefined as any);
      this.termNumber = _data["termNumber"];
      this.reason = _data["reason"];
    }
  }

  static fromJS(data: any): EditSuggestedTermDateRequest {
    data = typeof data === "object" ? data : {};
    let result = new EditSuggestedTermDateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termDateSuggestionId"] = this.termDateSuggestionId;
    data["startDate"] = this.startDate ? this.startDate.format("YYYY-MM-DD") : (undefined as any);
    data["endDate"] = this.endDate ? this.endDate.format("YYYY-MM-DD") : (undefined as any);
    data["termNumber"] = this.termNumber;
    data["reason"] = this.reason;
    return data;
  }
}

export interface IEditSuggestedTermDateRequest {
  termDateSuggestionId: number;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  termNumber: number;
  reason?: string | undefined;
}

export class TermDateHttpResponse implements ITermDateHttpResponse {
  termDateId!: number;
  termNumber!: number;
  firstDayOfTerm!: dayjs.Dayjs;
  lastDayOfTerm!: dayjs.Dayjs;
  year!: number;
  state?: string | undefined;
  confirmedDate?: dayjs.Dayjs | undefined;

  constructor(data?: ITermDateHttpResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termDateId = _data["termDateId"];
      this.termNumber = _data["termNumber"];
      this.firstDayOfTerm = _data["firstDayOfTerm"] ? dayjs(_data["firstDayOfTerm"].toString()) : (undefined as any);
      this.lastDayOfTerm = _data["lastDayOfTerm"] ? dayjs(_data["lastDayOfTerm"].toString()) : (undefined as any);
      this.year = _data["year"];
      this.state = _data["state"];
      this.confirmedDate = _data["confirmedDate"] ? dayjs(_data["confirmedDate"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): TermDateHttpResponse {
    data = typeof data === "object" ? data : {};
    let result = new TermDateHttpResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termDateId"] = this.termDateId;
    data["termNumber"] = this.termNumber;
    data["firstDayOfTerm"] = this.firstDayOfTerm ? this.firstDayOfTerm.format("YYYY-MM-DD") : (undefined as any);
    data["lastDayOfTerm"] = this.lastDayOfTerm ? this.lastDayOfTerm.format("YYYY-MM-DD") : (undefined as any);
    data["year"] = this.year;
    data["state"] = this.state;
    data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : (undefined as any);
    return data;
  }
}

export interface ITermDateHttpResponse {
  termDateId: number;
  termNumber: number;
  firstDayOfTerm: dayjs.Dayjs;
  lastDayOfTerm: dayjs.Dayjs;
  year: number;
  state?: string | undefined;
  confirmedDate?: dayjs.Dayjs | undefined;
}

export class ConfirmTermDateRequest implements IConfirmTermDateRequest {
  termDateId!: number;
  startDate!: dayjs.Dayjs;
  endDate!: dayjs.Dayjs;
  termNumber!: number;

  constructor(data?: IConfirmTermDateRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.termDateId = _data["termDateId"];
      this.startDate = _data["startDate"] ? dayjs(_data["startDate"].toString()) : (undefined as any);
      this.endDate = _data["endDate"] ? dayjs(_data["endDate"].toString()) : (undefined as any);
      this.termNumber = _data["termNumber"];
    }
  }

  static fromJS(data: any): ConfirmTermDateRequest {
    data = typeof data === "object" ? data : {};
    let result = new ConfirmTermDateRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["termDateId"] = this.termDateId;
    data["startDate"] = this.startDate ? this.startDate.format("YYYY-MM-DD") : (undefined as any);
    data["endDate"] = this.endDate ? this.endDate.format("YYYY-MM-DD") : (undefined as any);
    data["termNumber"] = this.termNumber;
    return data;
  }
}

export interface IConfirmTermDateRequest {
  termDateId: number;
  startDate: dayjs.Dayjs;
  endDate: dayjs.Dayjs;
  termNumber: number;
}

export class ComplaintListResponse implements IComplaintListResponse {
  data!: ComplaintItem[];
  total!: number;

  constructor(data?: IComplaintListResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.data = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["data"])) {
        this.data = [] as any;
        for (let item of _data["data"]) this.data!.push(ComplaintItem.fromJS(item));
      }
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): ComplaintListResponse {
    data = typeof data === "object" ? data : {};
    let result = new ComplaintListResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.data)) {
      data["data"] = [];
      for (let item of this.data) data["data"].push(item ? item.toJSON() : (undefined as any));
    }
    data["total"] = this.total;
    return data;
  }
}

export interface IComplaintListResponse {
  data: ComplaintItem[];
  total: number;
}

export class ComplaintItem implements IComplaintItem {
  issueId!: number;
  complaintId!: number;
  description!: string;
  created!: dayjs.Dayjs;
  complaintDate!: dayjs.Dayjs;
  modified!: dayjs.Dayjs;
  issueStatus!: string;
  issueType!: string;
  complaintType!: string;
  complaintTypeId?: number | undefined;
  primaryContactName!: string;
  serviceId!: number;
  customerAccountId?: number | undefined;
  resolutionDate?: dayjs.Dayjs | undefined;

  constructor(data?: IComplaintItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.issueId = _data["issueId"];
      this.complaintId = _data["complaintId"];
      this.description = _data["description"];
      this.created = _data["created"] ? dayjs(_data["created"].toString()) : (undefined as any);
      this.complaintDate = _data["complaintDate"] ? dayjs(_data["complaintDate"].toString()) : (undefined as any);
      this.modified = _data["modified"] ? dayjs(_data["modified"].toString()) : (undefined as any);
      this.issueStatus = _data["issueStatus"];
      this.issueType = _data["issueType"];
      this.complaintType = _data["complaintType"];
      this.complaintTypeId = _data["complaintTypeId"];
      this.primaryContactName = _data["primaryContactName"];
      this.serviceId = _data["serviceId"];
      this.customerAccountId = _data["customerAccountId"];
      this.resolutionDate = _data["resolutionDate"] ? dayjs(_data["resolutionDate"].toString()) : (undefined as any);
    }
  }

  static fromJS(data: any): ComplaintItem {
    data = typeof data === "object" ? data : {};
    let result = new ComplaintItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["issueId"] = this.issueId;
    data["complaintId"] = this.complaintId;
    data["description"] = this.description;
    data["created"] = this.created ? this.created.toISOString() : (undefined as any);
    data["complaintDate"] = this.complaintDate ? this.complaintDate.toISOString() : (undefined as any);
    data["modified"] = this.modified ? this.modified.toISOString() : (undefined as any);
    data["issueStatus"] = this.issueStatus;
    data["issueType"] = this.issueType;
    data["complaintType"] = this.complaintType;
    data["complaintTypeId"] = this.complaintTypeId;
    data["primaryContactName"] = this.primaryContactName;
    data["serviceId"] = this.serviceId;
    data["customerAccountId"] = this.customerAccountId;
    data["resolutionDate"] = this.resolutionDate ? this.resolutionDate.toISOString() : (undefined as any);
    return data;
  }
}

export interface IComplaintItem {
  issueId: number;
  complaintId: number;
  description: string;
  created: dayjs.Dayjs;
  complaintDate: dayjs.Dayjs;
  modified: dayjs.Dayjs;
  issueStatus: string;
  issueType: string;
  complaintType: string;
  complaintTypeId?: number | undefined;
  primaryContactName: string;
  serviceId: number;
  customerAccountId?: number | undefined;
  resolutionDate?: dayjs.Dayjs | undefined;
}

export class CreatePartnershipRequestRequest implements ICreatePartnershipRequestRequest {
  requestTypeId!: WorkflowIssueTypeEnum;
  description!: string;
  firstDateRequired?: dayjs.Dayjs | undefined;

  constructor(data?: ICreatePartnershipRequestRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.requestTypeId = _data["requestTypeId"];
      this.description = _data["description"];
      this.firstDateRequired = _data["firstDateRequired"]
        ? dayjs(_data["firstDateRequired"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): CreatePartnershipRequestRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreatePartnershipRequestRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["requestTypeId"] = this.requestTypeId;
    data["description"] = this.description;
    data["firstDateRequired"] = this.firstDateRequired ? this.firstDateRequired.toISOString() : (undefined as any);
    return data;
  }
}

export interface ICreatePartnershipRequestRequest {
  requestTypeId: WorkflowIssueTypeEnum;
  description: string;
  firstDateRequired?: dayjs.Dayjs | undefined;
}

export enum WorkflowIssueTypeEnum {
  PositiveFeedback = "positiveFeedback",
  HolidayClub = "holidayClub",
  Billing = "billing",
  StaffInteraction = "staffInteraction",
  ProgramQuality = "programQuality",
  Facilities = "facilities",
  FirstDayNPSFeedback = "firstDayNPSFeedback",
  SchoolContactComplaint = "schoolContactComplaint",
  PupilFreeDay = "pupilFreeDay",
  ExtendedHoursCare = "extendedHoursCare",
  AttendanceSupportFete = "attendanceSupportFete",
  FundingSupportChildren = "fundingSupportChildren",
  StaffTimeEducationSupport = "staffTimeEducationSupport",
  Other = "other",
  UnbundledPricing = "unbundledPricing",
  EarlyServiceStart = "earlyServiceStart",
  HolidayClubBillingPaymentsPricing = "holidayClubBillingPaymentsPricing",
  HolidayClubResourcesFacilities = "holidayClubResourcesFacilities",
  HolidayClubStaffInteraction = "holidayClubStaffInteraction",
  HolidayClubProgramQualityDelivery = "holidayClubProgramQualityDelivery",
  HolidayClubPositiveFeedback = "holidayClubPositiveFeedback",
  HolidayClubSafety = "holidayClubSafety",
  Safety = "safety",
  StaffInteractionFeedback = "staffInteractionFeedback",
  ProgramQualityDeliveryFeedback = "programQualityDeliveryFeedback",
  ResourcesFacilitiesFeedback = "resourcesFacilitiesFeedback",
  NoAvailableBookingsRatioAndCapacity = "noAvailableBookingsRatioAndCapacity",
  HolidayClubRocketeersMerchandise = "holidayClubRocketeersMerchandise",
}

export class GetPartnershipRequestsResponse implements IGetPartnershipRequestsResponse {
  requests!: PartnershipRequestResponse[];
  totalCount!: number;
  pageNumber!: number;
  pageSize!: number;
  totalPages!: number;

  constructor(data?: IGetPartnershipRequestsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
    if (!data) {
      this.requests = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["requests"])) {
        this.requests = [] as any;
        for (let item of _data["requests"]) this.requests!.push(PartnershipRequestResponse.fromJS(item));
      }
      this.totalCount = _data["totalCount"];
      this.pageNumber = _data["pageNumber"];
      this.pageSize = _data["pageSize"];
      this.totalPages = _data["totalPages"];
    }
  }

  static fromJS(data: any): GetPartnershipRequestsResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetPartnershipRequestsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.requests)) {
      data["requests"] = [];
      for (let item of this.requests) data["requests"].push(item ? item.toJSON() : (undefined as any));
    }
    data["totalCount"] = this.totalCount;
    data["pageNumber"] = this.pageNumber;
    data["pageSize"] = this.pageSize;
    data["totalPages"] = this.totalPages;
    return data;
  }
}

export interface IGetPartnershipRequestsResponse {
  requests: PartnershipRequestResponse[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export class PartnershipRequestResponse implements IPartnershipRequestResponse {
  issueId!: number;
  description?: string | undefined;
  created!: dayjs.Dayjs;
  modified!: dayjs.Dayjs;
  issueStatus?: string | undefined;
  issueType?: string | undefined;
  issueStatusId?: WorkflowIssueStatusEnum | undefined;
  issueTypeId?: WorkflowIssueTypeEnum | undefined;
  reporterName?: string | undefined;
  referenceUrl?: string | undefined;
  externalReferenceData?: string | undefined;
  firstDateRequired?: dayjs.Dayjs | undefined;

  constructor(data?: IPartnershipRequestResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.issueId = _data["issueId"];
      this.description = _data["description"];
      this.created = _data["created"] ? dayjs(_data["created"].toString()) : (undefined as any);
      this.modified = _data["modified"] ? dayjs(_data["modified"].toString()) : (undefined as any);
      this.issueStatus = _data["issueStatus"];
      this.issueType = _data["issueType"];
      this.issueStatusId = _data["issueStatusId"];
      this.issueTypeId = _data["issueTypeId"];
      this.reporterName = _data["reporterName"];
      this.referenceUrl = _data["referenceUrl"];
      this.externalReferenceData = _data["externalReferenceData"];
      this.firstDateRequired = _data["firstDateRequired"]
        ? dayjs(_data["firstDateRequired"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): PartnershipRequestResponse {
    data = typeof data === "object" ? data : {};
    let result = new PartnershipRequestResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["issueId"] = this.issueId;
    data["description"] = this.description;
    data["created"] = this.created ? this.created.toISOString() : (undefined as any);
    data["modified"] = this.modified ? this.modified.toISOString() : (undefined as any);
    data["issueStatus"] = this.issueStatus;
    data["issueType"] = this.issueType;
    data["issueStatusId"] = this.issueStatusId;
    data["issueTypeId"] = this.issueTypeId;
    data["reporterName"] = this.reporterName;
    data["referenceUrl"] = this.referenceUrl;
    data["externalReferenceData"] = this.externalReferenceData;
    data["firstDateRequired"] = this.firstDateRequired ? this.firstDateRequired.toISOString() : (undefined as any);
    return data;
  }
}

export interface IPartnershipRequestResponse {
  issueId: number;
  description?: string | undefined;
  created: dayjs.Dayjs;
  modified: dayjs.Dayjs;
  issueStatus?: string | undefined;
  issueType?: string | undefined;
  issueStatusId?: WorkflowIssueStatusEnum | undefined;
  issueTypeId?: WorkflowIssueTypeEnum | undefined;
  reporterName?: string | undefined;
  referenceUrl?: string | undefined;
  externalReferenceData?: string | undefined;
  firstDateRequired?: dayjs.Dayjs | undefined;
}

export enum WorkflowIssueStatusEnum {
  Unassigned = "unassigned",
  Assigned = "assigned",
  InProgress = "inProgress",
  Complete = "complete",
  Closed = "closed",
}

export class ReopenPartnershipRequestRequest implements IReopenPartnershipRequestRequest {
  notes!: string;

  constructor(data?: IReopenPartnershipRequestRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): ReopenPartnershipRequestRequest {
    data = typeof data === "object" ? data : {};
    let result = new ReopenPartnershipRequestRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["notes"] = this.notes;
    return data;
  }
}

export interface IReopenPartnershipRequestRequest {
  notes: string;
}

export class SchoolContactServiceResponse implements ISchoolContactServiceResponse {
  schoolContactId?: number | undefined;
  serviceId?: number | undefined;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  positionName?: string | undefined;
  positionId?: number | undefined;
  isPrimaryContact?: boolean | undefined;
  personId?: number | undefined;
  isContract?: boolean | undefined;
  serviceName?: string | undefined;
  regionalManagerId?: number | undefined;
  regionManagerFirstName?: string | undefined;
  regionManagerLastName?: string | undefined;
  state?: string | undefined;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postcode?: string | undefined;
  accessCode?: string | undefined;
  isNationalProgramEnabled!: boolean;
  isExclusionListRecipient!: boolean;

  constructor(data?: ISchoolContactServiceResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolContactId = _data["schoolContactId"];
      this.serviceId = _data["serviceId"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.positionName = _data["positionName"];
      this.positionId = _data["positionId"];
      this.isPrimaryContact = _data["isPrimaryContact"];
      this.personId = _data["personId"];
      this.isContract = _data["isContract"];
      this.serviceName = _data["serviceName"];
      this.regionalManagerId = _data["regionalManagerId"];
      this.regionManagerFirstName = _data["regionManagerFirstName"];
      this.regionManagerLastName = _data["regionManagerLastName"];
      this.state = _data["state"];
      this.streetLine1 = _data["streetLine1"];
      this.streetLine2 = _data["streetLine2"];
      this.suburb = _data["suburb"];
      this.postcode = _data["postcode"];
      this.accessCode = _data["accessCode"];
      this.isNationalProgramEnabled = _data["isNationalProgramEnabled"];
      this.isExclusionListRecipient = _data["isExclusionListRecipient"];
    }
  }

  static fromJS(data: any): SchoolContactServiceResponse {
    data = typeof data === "object" ? data : {};
    let result = new SchoolContactServiceResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["schoolContactId"] = this.schoolContactId;
    data["serviceId"] = this.serviceId;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["positionName"] = this.positionName;
    data["positionId"] = this.positionId;
    data["isPrimaryContact"] = this.isPrimaryContact;
    data["personId"] = this.personId;
    data["isContract"] = this.isContract;
    data["serviceName"] = this.serviceName;
    data["regionalManagerId"] = this.regionalManagerId;
    data["regionManagerFirstName"] = this.regionManagerFirstName;
    data["regionManagerLastName"] = this.regionManagerLastName;
    data["state"] = this.state;
    data["streetLine1"] = this.streetLine1;
    data["streetLine2"] = this.streetLine2;
    data["suburb"] = this.suburb;
    data["postcode"] = this.postcode;
    data["accessCode"] = this.accessCode;
    data["isNationalProgramEnabled"] = this.isNationalProgramEnabled;
    data["isExclusionListRecipient"] = this.isExclusionListRecipient;
    return data;
  }
}

export interface ISchoolContactServiceResponse {
  schoolContactId?: number | undefined;
  serviceId?: number | undefined;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  positionName?: string | undefined;
  positionId?: number | undefined;
  isPrimaryContact?: boolean | undefined;
  personId?: number | undefined;
  isContract?: boolean | undefined;
  serviceName?: string | undefined;
  regionalManagerId?: number | undefined;
  regionManagerFirstName?: string | undefined;
  regionManagerLastName?: string | undefined;
  state?: string | undefined;
  streetLine1?: string | undefined;
  streetLine2?: string | undefined;
  suburb?: string | undefined;
  postcode?: string | undefined;
  accessCode?: string | undefined;
  isNationalProgramEnabled: boolean;
  isExclusionListRecipient: boolean;
}

export class SchoolContactWithPermissionResponse implements ISchoolContactWithPermissionResponse {
  schoolContactId!: number;
  schoolId!: number;
  serviceId!: number;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  positionName?: string | undefined;
  positionId!: number;
  isPrimaryContact!: boolean;
  personId!: number;
  isContract!: boolean;
  serviceName?: string | undefined;
  permissions?: string[] | undefined;
  isExclusionListRecipient!: boolean;

  constructor(data?: ISchoolContactWithPermissionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolContactId = _data["schoolContactId"];
      this.schoolId = _data["schoolId"];
      this.serviceId = _data["serviceId"];
      this.email = _data["email"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.phone = _data["phone"];
      this.positionName = _data["positionName"];
      this.positionId = _data["positionId"];
      this.isPrimaryContact = _data["isPrimaryContact"];
      this.personId = _data["personId"];
      this.isContract = _data["isContract"];
      this.serviceName = _data["serviceName"];
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"]) this.permissions!.push(item);
      }
      this.isExclusionListRecipient = _data["isExclusionListRecipient"];
    }
  }

  static fromJS(data: any): SchoolContactWithPermissionResponse {
    data = typeof data === "object" ? data : {};
    let result = new SchoolContactWithPermissionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["schoolContactId"] = this.schoolContactId;
    data["schoolId"] = this.schoolId;
    data["serviceId"] = this.serviceId;
    data["email"] = this.email;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["phone"] = this.phone;
    data["positionName"] = this.positionName;
    data["positionId"] = this.positionId;
    data["isPrimaryContact"] = this.isPrimaryContact;
    data["personId"] = this.personId;
    data["isContract"] = this.isContract;
    data["serviceName"] = this.serviceName;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions) data["permissions"].push(item);
    }
    data["isExclusionListRecipient"] = this.isExclusionListRecipient;
    return data;
  }
}

export interface ISchoolContactWithPermissionResponse {
  schoolContactId: number;
  schoolId: number;
  serviceId: number;
  email?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  phone?: string | undefined;
  positionName?: string | undefined;
  positionId: number;
  isPrimaryContact: boolean;
  personId: number;
  isContract: boolean;
  serviceName?: string | undefined;
  permissions?: string[] | undefined;
  isExclusionListRecipient: boolean;
}

export class GetCrmPositionsResponse implements IGetCrmPositionsResponse {
  positionId!: number;
  name?: string | undefined;

  constructor(data?: IGetCrmPositionsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.positionId = _data["positionId"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): GetCrmPositionsResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetCrmPositionsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["positionId"] = this.positionId;
    data["name"] = this.name;
    return data;
  }
}

export interface IGetCrmPositionsResponse {
  positionId: number;
  name?: string | undefined;
}

export class ApiResponseResultOfSchoolContactWithPermissionResponse implements IApiResponseResultOfSchoolContactWithPermissionResponse {
  data?: SchoolContactWithPermissionResponse | undefined;

  constructor(data?: IApiResponseResultOfSchoolContactWithPermissionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.data = _data["data"] ? SchoolContactWithPermissionResponse.fromJS(_data["data"]) : (undefined as any);
    }
  }

  static fromJS(data: any): ApiResponseResultOfSchoolContactWithPermissionResponse {
    data = typeof data === "object" ? data : {};
    let result = new ApiResponseResultOfSchoolContactWithPermissionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["data"] = this.data ? this.data.toJSON() : (undefined as any);
    return data;
  }
}

export interface IApiResponseResultOfSchoolContactWithPermissionResponse {
  data?: SchoolContactWithPermissionResponse | undefined;
}

export class CreateSchoolContactRequest implements ICreateSchoolContactRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  positionId!: number;
  isPrimary!: boolean;
  permissions?: string[] | undefined;

  constructor(data?: ICreateSchoolContactRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.phone = _data["phone"];
      this.positionId = _data["positionId"];
      this.isPrimary = _data["isPrimary"];
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"]) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): CreateSchoolContactRequest {
    data = typeof data === "object" ? data : {};
    let result = new CreateSchoolContactRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["phone"] = this.phone;
    data["positionId"] = this.positionId;
    data["isPrimary"] = this.isPrimary;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions) data["permissions"].push(item);
    }
    return data;
  }
}

export interface ICreateSchoolContactRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  positionId: number;
  isPrimary: boolean;
  permissions?: string[] | undefined;
}

export class UpdateSchoolContactRequest implements IUpdateSchoolContactRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  positionId!: number;
  permissions?: string[] | undefined;

  constructor(data?: IUpdateSchoolContactRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.phone = _data["phone"];
      this.positionId = _data["positionId"];
      if (Array.isArray(_data["permissions"])) {
        this.permissions = [] as any;
        for (let item of _data["permissions"]) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateSchoolContactRequest {
    data = typeof data === "object" ? data : {};
    let result = new UpdateSchoolContactRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["phone"] = this.phone;
    data["positionId"] = this.positionId;
    if (Array.isArray(this.permissions)) {
      data["permissions"] = [];
      for (let item of this.permissions) data["permissions"].push(item);
    }
    return data;
  }
}

export interface IUpdateSchoolContactRequest {
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  positionId: number;
  permissions?: string[] | undefined;
}

export class ServiceVisitDocumentDto implements IServiceVisitDocumentDto {
  documentId?: number | undefined;
  serviceId?: number | undefined;
  service!: string;
  regionalManagerId?: number | undefined;
  regionalManagerFirstName!: string;
  regionalManagerLastName!: string;
  regionalManager!: string;
  visitType!: string;
  visitBy!: string;
  visitDate?: dayjs.Dayjs | undefined;
  authorName!: string;
  authorCreatedDate?: dayjs.Dayjs | undefined;
  lastModifiedBy!: string;
  lastModifiedDate?: dayjs.Dayjs | undefined;

  constructor(data?: IServiceVisitDocumentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.documentId = _data["documentId"];
      this.serviceId = _data["serviceId"];
      this.service = _data["service"];
      this.regionalManagerId = _data["regionalManagerId"];
      this.regionalManagerFirstName = _data["regionalManagerFirstName"];
      this.regionalManagerLastName = _data["regionalManagerLastName"];
      this.regionalManager = _data["regionalManager"];
      this.visitType = _data["visitType"];
      this.visitBy = _data["visitBy"];
      this.visitDate = _data["visitDate"] ? dayjs(_data["visitDate"].toString()) : (undefined as any);
      this.authorName = _data["authorName"];
      this.authorCreatedDate = _data["authorCreatedDate"]
        ? dayjs(_data["authorCreatedDate"].toString())
        : (undefined as any);
      this.lastModifiedBy = _data["lastModifiedBy"];
      this.lastModifiedDate = _data["lastModifiedDate"]
        ? dayjs(_data["lastModifiedDate"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): ServiceVisitDocumentDto {
    data = typeof data === "object" ? data : {};
    let result = new ServiceVisitDocumentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["documentId"] = this.documentId;
    data["serviceId"] = this.serviceId;
    data["service"] = this.service;
    data["regionalManagerId"] = this.regionalManagerId;
    data["regionalManagerFirstName"] = this.regionalManagerFirstName;
    data["regionalManagerLastName"] = this.regionalManagerLastName;
    data["regionalManager"] = this.regionalManager;
    data["visitType"] = this.visitType;
    data["visitBy"] = this.visitBy;
    data["visitDate"] = this.visitDate ? this.visitDate.toISOString() : (undefined as any);
    data["authorName"] = this.authorName;
    data["authorCreatedDate"] = this.authorCreatedDate ? this.authorCreatedDate.toISOString() : (undefined as any);
    data["lastModifiedBy"] = this.lastModifiedBy;
    data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : (undefined as any);
    return data;
  }
}

export interface IServiceVisitDocumentDto {
  documentId?: number | undefined;
  serviceId?: number | undefined;
  service: string;
  regionalManagerId?: number | undefined;
  regionalManagerFirstName: string;
  regionalManagerLastName: string;
  regionalManager: string;
  visitType: string;
  visitBy: string;
  visitDate?: dayjs.Dayjs | undefined;
  authorName: string;
  authorCreatedDate?: dayjs.Dayjs | undefined;
  lastModifiedBy: string;
  lastModifiedDate?: dayjs.Dayjs | undefined;
}

export class KeyContactResponse implements IKeyContactResponse {
  name?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  role?: string | undefined;
  position?: string | undefined;

  constructor(data?: IKeyContactResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.phone = _data["phone"];
      this.email = _data["email"];
      this.role = _data["role"];
      this.position = _data["position"];
    }
  }

  static fromJS(data: any): KeyContactResponse {
    data = typeof data === "object" ? data : {};
    let result = new KeyContactResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["phone"] = this.phone;
    data["email"] = this.email;
    data["role"] = this.role;
    data["position"] = this.position;
    return data;
  }
}

export interface IKeyContactResponse {
  name?: string | undefined;
  phone?: string | undefined;
  email?: string | undefined;
  role?: string | undefined;
  position?: string | undefined;
}

export class ServiceSession implements IServiceSession {
  rollId!: number;
  serviceId!: number;
  sessionId!: number;
  rollAvailabilityId!: number;
  sessionTypeId!: number;
  rollClassificationId!: number;
  rollName?: string | undefined;
  rollDate!: dayjs.Dayjs;
  minAgeMths!: number;
  maxAgeMths!: number;
  govCareTypeId!: number;
  labourCareTypeId!: number;
  startTime!: dayjs.Dayjs;
  endTime!: dayjs.Dayjs;
  sessionStartServerTime!: dayjs.Dayjs;
  sessionEndServerTime!: dayjs.Dayjs;

  constructor(data?: IServiceSession) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rollId = _data["rollId"];
      this.serviceId = _data["serviceId"];
      this.sessionId = _data["sessionId"];
      this.rollAvailabilityId = _data["rollAvailabilityId"];
      this.sessionTypeId = _data["sessionTypeId"];
      this.rollClassificationId = _data["rollClassificationId"];
      this.rollName = _data["rollName"];
      this.rollDate = _data["rollDate"] ? dayjs(_data["rollDate"].toString()) : (undefined as any);
      this.minAgeMths = _data["minAgeMths"];
      this.maxAgeMths = _data["maxAgeMths"];
      this.govCareTypeId = _data["govCareTypeId"];
      this.labourCareTypeId = _data["labourCareTypeId"];
      this.startTime = _data["startTime"] ? dayjs(_data["startTime"].toString()) : (undefined as any);
      this.endTime = _data["endTime"] ? dayjs(_data["endTime"].toString()) : (undefined as any);
      this.sessionStartServerTime = _data["sessionStartServerTime"]
        ? dayjs(_data["sessionStartServerTime"].toString())
        : (undefined as any);
      this.sessionEndServerTime = _data["sessionEndServerTime"]
        ? dayjs(_data["sessionEndServerTime"].toString())
        : (undefined as any);
    }
  }

  static fromJS(data: any): ServiceSession {
    data = typeof data === "object" ? data : {};
    let result = new ServiceSession();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["rollId"] = this.rollId;
    data["serviceId"] = this.serviceId;
    data["sessionId"] = this.sessionId;
    data["rollAvailabilityId"] = this.rollAvailabilityId;
    data["sessionTypeId"] = this.sessionTypeId;
    data["rollClassificationId"] = this.rollClassificationId;
    data["rollName"] = this.rollName;
    data["rollDate"] = this.rollDate ? this.rollDate.toISOString() : (undefined as any);
    data["minAgeMths"] = this.minAgeMths;
    data["maxAgeMths"] = this.maxAgeMths;
    data["govCareTypeId"] = this.govCareTypeId;
    data["labourCareTypeId"] = this.labourCareTypeId;
    data["startTime"] = this.startTime ? this.startTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["endTime"] = this.endTime ? this.endTime.format("d.hh:mm:ss.SSS") : (undefined as any);
    data["sessionStartServerTime"] = this.sessionStartServerTime
      ? this.sessionStartServerTime.toISOString()
      : (undefined as any);
    data["sessionEndServerTime"] = this.sessionEndServerTime
      ? this.sessionEndServerTime.toISOString()
      : (undefined as any);
    return data;
  }
}

export interface IServiceSession {
  rollId: number;
  serviceId: number;
  sessionId: number;
  rollAvailabilityId: number;
  sessionTypeId: number;
  rollClassificationId: number;
  rollName?: string | undefined;
  rollDate: dayjs.Dayjs;
  minAgeMths: number;
  maxAgeMths: number;
  govCareTypeId: number;
  labourCareTypeId: number;
  startTime: dayjs.Dayjs;
  endTime: dayjs.Dayjs;
  sessionStartServerTime: dayjs.Dayjs;
  sessionEndServerTime: dayjs.Dayjs;
}

export class ServiceAdditionalInfoResponse implements IServiceAdditionalInfoResponse {
  serviceId!: number;
  hasCurrentHolidayPrograms!: boolean;
  hasUpcomingHolidayProgramDays!: boolean;
  hasUpcomingNationalDayPrograms!: boolean;

  constructor(data?: IServiceAdditionalInfoResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (this as any)[property] = (data as any)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.serviceId = _data["serviceId"];
      this.hasCurrentHolidayPrograms = _data["hasCurrentHolidayPrograms"];
      this.hasUpcomingHolidayProgramDays = _data["hasUpcomingHolidayProgramDays"];
      this.hasUpcomingNationalDayPrograms = _data["hasUpcomingNationalDayPrograms"];
    }
  }

  static fromJS(data: any): ServiceAdditionalInfoResponse {
    data = typeof data === "object" ? data : {};
    let result = new ServiceAdditionalInfoResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["serviceId"] = this.serviceId;
    data["hasCurrentHolidayPrograms"] = this.hasCurrentHolidayPrograms;
    data["hasUpcomingHolidayProgramDays"] = this.hasUpcomingHolidayProgramDays;
    data["hasUpcomingNationalDayPrograms"] = this.hasUpcomingNationalDayPrograms;
    return data;
  }
}

export interface IServiceAdditionalInfoResponse {
  serviceId: number;
  hasCurrentHolidayPrograms: boolean;
  hasUpcomingHolidayProgramDays: boolean;
  hasUpcomingNationalDayPrograms: boolean;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any,
): any {
  throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}

const customTimeParser: PluginFunc = (option, dayjsClass, dayjsFactory) => {
  const proto: any = dayjsClass.prototype;
  const oldParse = proto.parse;
  proto.parse = function (cfg: any) {
    const { date } = cfg;
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(\.\d{1,})?$/;
    if (typeof date === "string" && date && timeRegex.test(date)) {
      cfg.date = "1970-01-01T" + date;
    }
    oldParse.call(this, cfg);
  };
};

dayjs.extend(customTimeParser);
